// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: util/common/lcmtypes/fault_t.lcm
import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmEnumMsg from "@skydio/lcm/src/enum";

enum option_t {
  INVALID = 0,
  TASK_QUEUE_RUNNING = 59,
  LIGHTING_ATTACHMENT_DISCONNECTED = 316,
  BATTERY_LOW_LAND = 56,
  PLANNER_UNRELIABLE = 4,
  POSE_POLISHER_UNRELIABLE = 5,
  NIGHT_MODE_HEADING_UNINITIALIZED = 214,
  VIO_UNRELIABLE = 6,
  VIO_DEGRADED = 148,
  VIO_VERY_DEGRADED = 459,
  GPS_DEGRADED = 381,
  VIO_UNRELIABLE_REDUCED_OBSTACLES = 198,
  VIO_STATIC_INITIALIZATION_FAILED = 216,
  POSE_SOURCE_DEGRADED = 468,
  VEHICLE_UNCALIBRATED = 248,
  VOXELS_UNRELIABLE = 7,
  STEREO_UNRELIABLE = 8,
  SUBJECT_UNRELIABLE = 9,
  IGNORE_OBSTACLES = 11,
  IGNORE_SOME_FAULTS = 12,
  LOGGING_SPACE_LOW = 13,
  LOGGING_SPACE_CRITICAL = 54,
  LOGGING_SPACE_LOW_BETA = 196,
  LOGGING_SPACE_LOW_NOT_DISMISSED = 477,
  EMMC_SPACE_LOW = 293,
  EMMC_SPACE_LOW_QCU = 428,
  EMMC_SPACE_CRITICAL = 437,
  EMMC_SPACE_CRITICAL_QCU = 438,
  FLIGHT_LOGGER_UNRELIABLE = 14,
  MOTOR_NOT_SPINNING = 15,
  LOST_RC = 16,
  SUBJECT_CAMERA_UNRELIABLE = 17,
  SUBJECT_CAMERA_STOPPED = 358,
  BASE_PROCESSES_STOPPED = 18,
  FLIGHT_PROCESSES_STOPPED = 19,
  NOT_ARMED = 25,
  MOTOR_SYNC_LOST = 26,
  MISSING_IMAGES = 30,
  VEHICLE_STUCK = 31,
  IMU_DRIVER_UNRELIABLE = 32,
  VEHICLE_IMU_SOURCE_NOT_PRIMARY = 608,
  BARO_DRIVER_UNRELIABLE = 33,
  NAV_CAMERAS_UNRELIABLE = 34,
  AMBARELLA_DRIVER_UNRELIABLE = 36,
  SKILLS_UNRELIABLE = 110,
  HAND_TAKEOFF_OBSTRUCTED = 38,
  HAND_TAKEOFF_SHALLOW_OBSTRUCTED = 116,
  HAND_TAKEOFF_VERTICAL_OBSTRUCTED = 118,
  BAD_CPU_FREQUENCY = 39,
  BAD_GPU_FREQUENCY = 40,
  HIGH_WINDS_WARN = 41,
  HIGH_WINDS_SEVERE = 103,
  HIGH_WINDS_LAND = 104,
  DIRTY_CAMERAS_LOW = 23,
  DIRTY_CAMERAS_HIGH = 24,
  COLLISION = 49,
  MOTOR_HOT_WARNING = 51,
  MOTOR_HOT_CRITICAL = 52,
  PLANNER_STATE_UNRELIABLE = 57,
  EXECUTIVE_MANAGER_UNRELIABLE = 58,
  TASK_QUEUE_RUNNING_UNINTERRUPTIBLE = 420,
  TASK_QUEUE_RUNNING_INTERRUPTIBLE = 421,
  AMBARELLA_SD_STILL_MOUNTED = 60,
  BATTERY_TOO_COLD = 63,
  BATTERY_NEEDS_HEATING = 344,
  BATTERY_HEATER_ON = 345,
  BATTERY_TOO_COLD_BUT_IS_HEATING = 348,
  BATTERY_TOO_COLD_LIMP_OK = 349,
  USBC_IN_USE = 65,
  USBC_SECURITY_KEY_IN_USE = 249,
  CPU_TOO_HIGH = 66,
  GPU_TOO_HIGH = 289,
  VEHICLE_TOO_HOT_CRITICAL = 48,
  VEHICLE_TOO_HOT_WARNING = 67,
  AMBARELLA_TOO_HOT = 68,
  GPS_UNRELIABLE = 69,
  GPS_AWAITING_HEADING = 375,
  PRE_FLIGHT_TASKS_REQUIRED = 71,
  ENCRYPTION_BLOCKING_PRE_FLIGHT_TASKS = 554,
  ENCRYPTION_BLOCKING_PRE_FLIGHT_TASKS_NOT_DISMISSED = 555,
  GAP_TOO_SMALL = 73,
  HAND_TAKEOFF_DANGEROUS = 74,
  ENVIRONMENT_DANGEROUS = 76,
  HAND_TAKEOFF_DANGEROUS_HIGH_GRADIENT = 91,
  HAND_TAKEOFF_DANGEROUS_DARK = 97,
  MOTOR_FLASH_IN_PROGRESS = 77,
  MOTOR_FLASH_FAILURE = 78,
  TEGRA_STATE_ESTIMATION_FAILED = 79,
  EMERGENCY_LANDING_AIRHAWK_ONLY = 80,
  EMERGENCY_LANDING_TEGRA_POSES = 81,
  VELOCITY_CONTROL_DIVERGED = 82,
  POSITION_CONTROL_DIVERGED = 93,
  YAW_CONTROL_DIVERGED = 105,
  PILOT_NOT_READY_TO_FLY = 83,
  PILOT_WAITING_TO_FLY = 84,
  PILOT_WAITING_TO_BROWSE = 85,
  GPS_UNRELIABLE_HOVER = 86,
  TEGRA_STATE_ESTIMATION_HOVER = 87,
  MOTOR_QUALITY = 90,
  GIMBAL_IMU_UNRELIABLE = 240,
  GIMBAL_UNCALIBRATED = 241,
  GIMBAL_CONTROLLER_UNRELIABLE = 242,
  GIMBAL_ENCODER_UNRELIABLE = 286,
  GIMBAL_ESTIMATOR_FAILED = 243,
  GIMBAL_ESTIMATOR_MISSING_IMU_DATA = 244,
  GIMBAL_ESTIMATOR_ACCEL_NORM_TOO_HIGH = 245,
  GIMBAL_ESTIMATOR_NEEDS_INITIALIZER = 246,
  GIMBAL_ESTIMATOR_INSUFFICIENT_TIME = 247,
  GIMBAL_ESTIMATOR_COMPUTING_MOTOR_ANGLES = 269,
  GIMBAL_UNRELIABLE = 35,
  FALCON_HOOD = 88,
  GIMBAL_OBSTRUCTED = 89,
  GIMBAL_FREAK_OUT = 102,
  GIMBAL_EMBEDDED_ESTIMATOR_NOT_INITIALIZED = 251,
  GIMBAL_EMBEDDED_ESTIMATOR_STALE_REFERENCE = 252,
  GIMBAL_VISION_ESTIMATOR_UNRELIABLE = 94,
  GIMBAL_FLASHLIGHT_TOO_HOT = 372,
  GIMBAL_CONFIG_NOT_YET_FINALIZED = 485,
  EXTERNAL_TORQUE_NORM_TOO_HIGH = 95,
  ROTOR_SPEED_CONTROL_DIVERGED = 96,
  AUTOEXPOSURE_HAS_NOT_CONVERGED = 99,
  MEDIA_TRANSCODE_POSSIBLE = 100,
  NOT_ACHIEVING_MOVEMENT_COMMAND = 106,
  CONTACT = 107,
  BATTERY_TOO_HOT_WARNING = 108,
  BATTERY_TOO_HOT_CRITICAL = 109,
  BATTERY_NOT_CHARGING_TOO_HOT = 302,
  BATTERY_NOT_CHARGING_TOO_COLD = 303,
  MEMORY_LOW = 112,
  TOO_MANY_PAGE_FAULTS = 113,
  BATTERY_GAS_GAUGE_ERROR = 114,
  BATTERY_GAS_GAUGE_VERSION_MISMATCH = 350,
  VEHICLE_IN_HAND = 115,
  FLIGHT_LOGS_NOT_MOUNTED = 119,
  MOTOR_SPINUP_FAILURE = 120,
  MEDIA_SD_MISSING = 122,
  MEDIA_SD_UNFORMATTED = 124,
  MEDIA_SD_CORRUPTED = 131,
  MEDIA_SD_SLOW = 126,
  MEDIA_SPACE_LOW = 50,
  MEDIA_SPACE_CRITICAL = 55,
  MEDIA_SPACE_FULL = 294,
  INSUFFICIENT_MEDIA_SD_STORAGE_FOR_MISSION = 312,
  MEDIA_SD_NEEDS_TO_AUTODELETE = 224,
  MEDIA_SD_WRONG_ENCRYPTION_KEY = 226,
  MEDIA_SD_MISSING_NOT_DISMISSED = 123,
  MEDIA_SD_UNFORMATTED_NOT_DISMISSED = 125,
  MEDIA_SD_CORRUPTED_NOT_DISMISSED = 132,
  MEDIA_SD_SLOW_NOT_DISMISSED = 127,
  MEDIA_SPACE_LOW_NOT_DISMISSED = 128,
  MEDIA_SD_LOADING_DTED_FILES = 298,
  LOGGING_SD_MISSING = 193,
  LOGGING_SD_MISSING_NOT_DISMISSED = 476,
  LOGGING_SD_WRONG_FILESYSTEM = 151,
  LOGGING_SD_WRONG_FILESYSTEM_NOT_DISMISSED = 528,
  LOGGING_SD_WRONG_FILESYSTEM_IN_USE = 152,
  LOGGING_SD_SLOW = 222,
  LOGGING_SD_NOT_ENCRYPTED = 225,
  LOGGING_SD_LOCKED = 232,
  LOGGING_SD_SECURITY_KEY_REQUIRED = 233,
  LOGGING_SD_SECURITY_TOKEN_REQUIRED = 564,
  LOGGING_SD_SECURITY_ACTIVATION_IN_PROGRESS = 234,
  LOGGING_SD_SECURITY_ACTIVATION_FAILED = 235,
  LOGGING_SD_NOT_MOUNTED = 571,
  BATTERY_CRITICAL = 1,
  BATTERY_CRITICAL_PILOT_WARNING = 600,
  BATTERY_CRITICAL_FORCE_FAST_DESCENT = 365,
  BATTERY_LOW = 70,
  BATTERY_LOW_RETURN_PILOT_WARNING = 601,
  BATTERY_LOW_RETURN = 351,
  BATTERY_LOW_RETURN_TO_DOCK = 210,
  BATTERY_LOW_RETURN_TO_LOST_CONNECTION = 206,
  BATTERY_LOW_SAFE_LANDING_UNREACHABLE = 367,
  BATTERY_LOW_DISABLE_AUTONOMOUS = 223,
  BATTERY_VOLTAGE_IMBALANCE = 282,
  BATTERY_VOLTAGE_IMBALANCE_LAND = 287,
  BATTERY_HIGH_CURRENT = 154,
  BATTERY_HIGH_CURRENT_CRITICAL = 155,
  PAGE_ALLOCATION_FAILURE = 133,
  LOST_PHONE_COMM_SHORT = 2,
  LOST_CONNECTION_RETURN = 432,
  LOST_CONNECTION_RTH = 139,
  LOST_CONNECTION_RTD = 209,
  LOST_CONNECTION_LAND = 140,
  LOST_CONNECTION_STOP_TRACK = 208,
  PHONE_GPS_QUALITY_INSUFFICIENT = 134,
  VEHICLE_GPS_QUALITY_INSUFFICIENT = 135,
  VEHICLE_GPS_QUALITY_BLOCKING = 150,
  VEHICLE_GPS_INOPERATIVE = 283,
  BEACON_GPS_QUALITY_BLOCKING = 136,
  BEACON_NEEDS_ASSISTNOW = 137,
  BEACON_GPS_QUALITY_INSUFFICIENT = 141,
  RID_BEACON_GPS_INOPERATIVE = 290,
  USER_CAMERA_MODE_SWITCH = 144,
  USER_CAMERA_PREVIEW_FORMAT_SWITCH = 578,
  UNCANCELLABLE_LANDING = 142,
  PILOT_STILL_WAITING_TO_FLY = 143,
  BEACON_UPDATE_IN_PROGRESS = 147,
  JOYSTICKS_UPDATE_IN_PROGRESS = 149,
  SHOULD_CONNECT_THROUGH_BEACON = 145,
  SHOULD_CONNECT_THROUGH_JOYSTICKS = 146,
  SHOULD_CONNECT_SKYSTICKS = 280,
  COMMANDING_BEYOND_SAFETY_HEIGHT = 153,
  PHONE_BATTERY_LOW = 27,
  PHONE_BATTERY_CRITICAL = 28,
  BEACON_BATTERY_LOW = 157,
  BEACON_BATTERY_CRITICAL = 167,
  JOYSTICKS_BATTERY_LOW = 158,
  SKYSTICKS_BATTERY_LOW = 354,
  PHONE_BATTERY_LOW_NOT_DISMISSED = 156,
  BEACON_BATTERY_LOW_NOT_DISMISSED = 159,
  JOYSTICKS_BATTERY_LOW_NOT_DISMISSED = 160,
  SKYSTICKS_BATTERY_LOW_NOT_DISMISSED = 355,
  FLIGHT_DECK_OUT_OF_SYNC = 161,
  BEACON_UPDATE_READY = 162,
  JOYSTICKS_UPDATE_READY = 163,
  STUCK_SAFETY_HEIGHT = 164,
  BEACON_GPS_QUALITY_INSUFFICIENT_TRACKING_PAUSED = 165,
  BEACON_GPS_QUALITY_INSUFFICIENT_WITH_VISUAL = 166,
  MIND_THE_GAP = 168,
  MIND_THE_STUCK_SAFETY_HEIGHT = 169,
  BATTERY_MESSAGES_UNRELIABLE = 53,
  BATTERY_RESET_REQUIRED = 170,
  BATTERY_UPDATE_REQUIRED = 478,
  TEGRA_REBOOTED_IN_FLIGHT = 171,
  MAYBE_TEGRA_REBOOTED_IN_FLIGHT = 313,
  BACKTRACK_UNAVAILABLE_TEGRA_REBOOTED = 329,
  TOO_DARK_CRITICAL = 29,
  TOO_DARK_HOVER = 61,
  TOO_DARK_WARNING = 62,
  TOO_DARK_FOR_VISION = 172,
  TOO_DARK_TRY_NIGHT_AUTONOMY = 378,
  TOO_DARK_SOLAR_ANGLE = 550,
  AUTO_SWITCHED_TO_LOW_LIGHT = 551,
  TAKEOFF_NEEDS_MOTION = 174,
  HAND_WAVE_CAL_NEEDS_STOP_WAVING = 253,
  HAND_WAVE_UNAVAILABLE = 260,
  TAKEOFF_BLOCKED_BY_POSE_POLISHER = 175,
  TAKEOFF_NEEDS_HEALTHY_AEKF = 579,
  NOT_STABLE_FOR_TAKEOFF = 21,
  TOO_FAST_FOR_TAKEOFF = 22,
  TOO_FAST_FOR_TAKEOFF_NIGHT = 176,
  NOT_STABLE_FOR_TAKEOFF_NIGHT = 177,
  TOO_FAST_FOR_TAKEOFF_VESSEL = 258,
  NOT_STABLE_FOR_TAKEOFF_VESSEL = 259,
  TEGRA_REQUIRES_EMERGENCY_LAND = 179,
  IS_FIRST_PILOTED_EMERGENCY_LAND = 368,
  IS_PILOTED_EMERGENCY_LAND = 299,
  COMMANDED_EMERGENCY_LAND = 366,
  EMERGENCY_LAND_MOTOR_ARMING_COMMAND = 180,
  EMERGENCY_LAND_LOST_RC_LINK = 181,
  EMERGENCY_LAND_TEGRA_HEALTH_MONITOR_STALE = 182,
  EMERGENCY_LAND_TEGRA_ATTITUDE_COMMAND_STALE = 183,
  EMERGENCY_LAND_RC_EMERGENCY_LAND_COMMAND = 184,
  EMERGENCY_LAND_SYMPC_CONTROLLER_FAILED = 185,
  EMERGENCY_LAND_NO_STATE_ESTIMATE_AVAILABLE = 186,
  JOYSTICKS_INPUT_PRE_TAKEOFF = 187,
  TRIGGER_OR_ROLLER_INPUT_PRE_TAKEOFF = 219,
  JOYSTICKS_INPUT_ERRATIC = 386,
  MAGNETOMETER_NEEDS_CALIBRATION = 188,
  MAGNETOMETER_NEEDS_GPS = 250,
  ATTI_RTX_REQUIRES_MAG_CAL = 423,
  ATTI_RTX_MAG_REQUIRES_LOCATION = 425,
  USER_CAMERA_PHOTO_CAPTURE = 190,
  COMMANDED_PAST_POOR_GPS_HEIGHT = 191,
  COMMANDED_PAST_MAX_HEIGHT = 192,
  COMMANDED_PAST_INDOOR_POOR_GPS_HEIGHT = 229,
  COMMANDED_PAST_DENSITY_ALTITUDE = 415,
  COMMANDED_PAST_POOR_GPS_HEIGHT_NOT_DISMISSED = 227,
  COMMANDED_PAST_MAX_HEIGHT_NOT_DISMISSED = 228,
  COMMANDED_PAST_INDOOR_POOR_GPS_HEIGHT_NOT_DISMISSED = 230,
  AT_GEOFENCE_EDGE = 276,
  AT_GEOFENCE_EDGE_NOT_DISMISSED = 277,
  RETURNING_TO_GEOFENCE = 278,
  RETURNING_TO_GEOFENCE_NOT_DISMISSED = 279,
  FAR_OUTSIDE_GEOFENCE = 308,
  GEOFENCE_UNRELIABLE = 318,
  GEOFENCE_GPS_REQUIRED = 590,
  GEOFENCE_AGL_HEIGHTS_REQUIRED = 591,
  VEHICLE_NEEDS_ASSISTNOW = 194,
  SKILLS_LATENCY_HIGH = 195,
  DOCK_NOT_READY_FOR_TAKEOFF = 197,
  WEBRTC_OFFLINE = 199,
  DOCK_DISCONNECTED = 200,
  DOCK_DETECTED = 201,
  VEHICLE_ON_SOME_TAKEOFF_SURFACE = 306,
  DOCK_IN_INSPECTION_MODE = 309,
  DIGITAL_ZOOM_UNAVAILABLE = 202,
  SUPERZOOM_UNAVAILABLE_SUBJECT_TRACKING = 203,
  MOTOR_CURRENT_WARNING = 204,
  MOTOR_CURRENT_CRITICAL = 205,
  MOTOR_IDLE_OVERCURRENT_CRITICAL = 429,
  MOTOR_IDLE_OVERCURRENT_WARNING = 442,
  AIRHAWK_ATTITUDE_CONTROL_REQ_RESTART = 207,
  DEFAULT_WIFI_AP_CREDENTIALS = 211,
  IMPERFECT_CONTACT_WITH_DOCK = 212,
  LOST_CONNECTION_DROP_VIDEO = 217,
  ARM_IMPROPER_POSITION_VISION = 218,
  ARM_IMPROPER_POSITION_CRITICAL = 301,
  ARM_IMPROPER_POSITION_VISION_BLOCK_TAKEOFF = 304,
  VIO_CALIBRATIONS_NOT_CONVERGED = 220,
  AUTO_GPS_INITIALIZATION_FAILED = 221,
  BEACON_BARO_OFFSET_NEEDED = 231,
  DOCK_VEHICLE_PAIRING_MISMATCH = 261,
  RID_KEY_REQUIRED = 255,
  MOTOR_VIBE_CHECK_PENDING = 256,
  EXCESSIVE_MOTOR_VIBE = 257,
  MANUAL_MODE_RECOMMENDED = 262,
  RID_CHECK_STARTED = 263,
  WIFI_NO_CONFIGURED_SSIDS_FOUND = 264,
  WIFI_AUTHENTICATION_ERROR = 265,
  WIFI_CONNECTION_TIMEOUT = 266,
  WIFI_CHIP_CRASHED = 562,
  CONTROLLER_GPS_QUALITY_INSUFFICIENT = 267,
  RID_CONTROLLER_GPS_INOPERATIVE = 291,
  RID_RPIC_GPS_INOPERATIVE = 307,
  DOCK_CRADLE_EXTENDED_PRE_TAKEOFF = 305,
  IS_BASESTATION_TAKEOFF_SURFACE = 445,
  IS_BASESTATION_LANDING_SURFACE = 281,
  LANDED_OUTSIDE_DOCK = 296,
  AIRHAWK_RT_LOSS = 268,
  AIRHAWK_TIMING_FAULT = 581,
  LIVEKIT_NO_CONFIG = 270,
  LIVEKIT_CONFIG_MISMATCH = 271,
  LIVEKIT_NOT_ENABLED = 272,
  LIVEKIT_CONNECTED = 273,
  LIVEKIT_CONNECTION_FAILED = 274,
  VEHICLE_GPS_QUALITY_BLOCKING_TWILIGHT = 285,
  FLIGHT_TERMINATED = 284,
  NAV_CAMERA_LOGGING_DEGRADED = 288,
  SKILLS_TASKS_PENDING = 292,
  DOCK_COMMS_UNRELIABLE = 295,
  CLOUD_ENV_OUT_OF_SYNC = 376,
  TRACK_TRAJECTORY_STUCK_ON_OBSTACLES = 297,
  SKILLS_TASK_NEEDS_DECRYPTION = 363,
  USER_CAMERA_SLOW_MODE_SWITCH = 300,
  NVU_DISCONNECTED = 310,
  QCU_DISCONNECTED = 311,
  BARO_MEASUREMENT_UNRELIABLE = 314,
  WAYPOINTS_UNRELIABLE = 315,
  A_STAR_FRONT_UNRELIABLE = 534,
  WAYPOINT_TASK_STUCK_ON_OBSTACLE = 352,
  WAYPOINT_TASK_STUCK_ON_GEOFENCE = 353,
  WAYPOINT_TASK_STUCK_ON_NEARBY_DRONE = 535,
  DOCK_CLIENT_UNRELIABLE = 317,
  SPURIOUS_VOXELS_DAY = 319,
  SPURIOUS_VOXELS_NIGHT = 356,
  SPURIOUS_VOXELS_DEBUG = 361,
  BAD_GPU_FREQUENCY_QCU = 320,
  CPU_TOO_HIGH_QCU = 321,
  GPU_TOO_HIGH_QCU = 322,
  BASE_PROCESSES_STOPPED_QCU = 323,
  FLIGHT_PROCESSES_STOPPED_QCU = 324,
  MEMORY_LOW_QCU = 325,
  TOO_MANY_PAGE_FAULTS_QCU = 326,
  FLIGHT_DECK_OUT_OF_SYNC_QCU = 327,
  TOF_UNRELIABLE = 328,
  TOF_UNRELIABLE_FOR_FAST_DESCENT_LANDING = 332,
  INFRARED_CAMERA_UNRELIABLE = 330,
  TOO_FAST_NIGHT_AUTONOMY = 331,
  VEHICLE_RADIO_UPDATE_IN_PROGRESS = 333,
  ATTACHMENT_CHANGE_DETECTED = 334,
  MISMATCHED_NIGHTSENSE_ATTACHMENT_DETECTED = 400,
  MIXED_NIGHTSENSE_ATTACHMENTS_DETECTED = 401,
  RTK_PPK_ATTACHMENT_CONNECTED = 402,
  RTK_PPK_ATTACHMENT_CONNECTED_NOT_DISMISSED = 413,
  NIGHTSENSE_ATTACHMENT_DEGRADED = 403,
  NIGHTSENSE_ATTACHMENT_DEGRADED_NOT_DISMISSED = 404,
  NIGHTSENSE_DISABLED_ATTACHMENT_FAILURE = 405,
  NIGHTSENSE_DISABLED_ATTACHMENT_FAILURE_NOT_DISMISSED = 406,
  NIGHTSENSE_DISABLED_ATTACHMENT_DISCONNECTED = 407,
  NIGHTSENSE_DISABLED_ATTACHMENT_DISCONNECTED_NOT_DISMISSED = 408,
  NIGHTSENSE_UNAVAILABLE_ATTACHMENT_MISSING = 409,
  NIGHTSENSE_UNAVAILABLE_ATTACHMENT_MISSING_NOT_DISMISSED = 410,
  PARACHUTE_FIRMWARE_VERSION_MISMATCH = 506,
  PARACHUTE_DEGRADED = 507,
  PARACHUTE_DEGRADED_NOT_DISMISSED = 522,
  PARACHUTE_NON_CRITICAL_FAILURE = 508,
  PARACHUTE_NON_CRITICAL_FAILURE_NOT_DISMISSED = 523,
  PARACHUTE_CRITICAL_FAILURE = 509,
  PARACHUTE_CRITICAL_FAILURE_NOT_DISMISSED = 524,
  PARACHUTE_CRITICAL_ATS_FAILURE = 594,
  PARACHUTE_CRITICAL_ATS_FAILURE_NOT_DISMISSED = 595,
  PARACHUTE_COMMS_LOST = 510,
  PARACHUTE_AIRHAWK_HEARTBEAT_STALE = 511,
  PARACHUTE_SELF_CHECK_IN_PROGRESS = 512,
  PARACHUTE_SELF_CHECK_MARGINAL = 513,
  PARACHUTE_SELF_CHECK_MARGINAL_NOT_DISMISSED = 525,
  PARACHUTE_SELF_CHECK_FAILED = 514,
  PARACHUTE_HAS_LOGS = 515,
  PARACHUTE_REQUIRED_BUT_MISSING = 602,
  PARACHUTE_REQUIRED_BUT_MISSING_NOT_DISMISSED = 603,
  PARACHUTE_EXPECTED_BUT_MISSING = 536,
  PARACHUTE_EXPECTED_BUT_MISSING_NOT_DISMISSED = 537,
  PARACHUTE_UNKNOWN_HARDWARE_VERSION = 583,
  PARACHUTE_UNKNOWN_HARDWARE_VERSION_NOT_DISMISSED = 584,
  PARACHUTE_EXPIRED = 597,
  PARACHUTE_EXPIRED_NOT_DISMISSED = 598,
  FLASH_DRIVE_REQUIRED = 335,
  HOUSEKEEPER_MCU_VERSION_MISMATCH = 336,
  AIRHAWK_MCU_VERSION_MISMATCH = 337,
  GIMBAL_MCU_VERSION_MISMATCH = 338,
  SOC_FLASHPACK_MISMATCH = 339,
  SOC_CONFIG_MISMATCH = 340,
  SOC_SERIAL_NUMBER_MISMATCH = 341,
  OTA_IN_PROGRESS = 342,
  FIRMWARE_MISCONFIGURED = 343,
  AIRHAWK_SERIAL_CONNECTION_LOST = 346,
  AIRHAWK_SERIAL_CONNECTION_LOST_QCU = 347,
  OBSTACLE_MARGINS_CANNOT_EXPAND = 357,
  MOTOR_TAKEOFF_CURRENT_CRITICAL = 359,
  RELATIVE_HEADING_ESTIMATE_UNAVAILABLE = 360,
  IMU_SATURATION_ON_TAKEOFF = 362,
  VEHICLE_GPS_RESET = 364,
  PRE_DOCK_TAKEOFF_VEHICLE_GPS_RESET_UNSUCCESSFUL = 369,
  GIMBAL_FLASH_FAILED = 370,
  INFRARED_CAMERA_POOR_ACCURACY = 371,
  GIMBAL_TYPE_INCOMPATIBLE = 373,
  FRONT_UNRELIABLE = 374,
  MOTOR_OSCILLATION_DETECTED = 377,
  ATTACHMENT_OLD_SIDE_ATTACHMENT_HARDWARE = 388,
  ATTACHMENT_WRONG_CABLE_ORIENTATION = 389,
  ATTACHMENT_ENUMERATION_IN_PROGRESS = 439,
  ATTACHMENT_IN_INVALID_PORT_TOP = 390,
  ATTACHMENT_IN_INVALID_PORT_BOTTOM = 391,
  ATTACHMENT_IN_INVALID_PORT_LEFT = 392,
  ATTACHMENT_IN_INVALID_PORT_RIGHT = 393,
  ATTACHMENT_INSPECT_OR_REPLACE_TOP = 394,
  ATTACHMENT_INSPECT_OR_REPLACE_BOTTOM = 395,
  ATTACHMENT_INSPECT_OR_REPLACE_LEFT = 396,
  ATTACHMENT_INSPECT_OR_REPLACE_RIGHT = 397,
  ATTACHMENT_NIGHTSENSE_VERSION_MISMATCH = 379,
  ATTACHMENT_NIGHTSENSE_UPDATE_FAILED = 384,
  ATTACHMENT_NIGHTSENSE_UPDATE_FAILED_NOT_DISMISSED = 385,
  ATTACHMENT_SPOTLIGHT_BRIGHTNESS_THROTTLING = 398,
  ATTACHMENT_SPOTLIGHT_THERMAL_SHUTDOWN = 416,
  ATTACHMENT_SPOTLIGHT_ABOVE_TOUCH_TEMP = 399,
  ATTACHMENT_PARACHUTE_DEPLOYED = 441,
  ATTACHMENT_DROPPER_FIRMWARE_VERSION_MISMATCH = 586,
  ATTACHMENT_DROPPER_FIRMWARE_UPDATE_FAILED = 587,
  ATTACHMENT_DROPPER_FIRMWARE_UPDATE_FAILED_NOT_DISMISSED = 588,
  ATTACHMENT_DROPPER_CRITICAL_FAILURE = 589,
  ATTACHMENT_DROPPER_CRITICAL_FAILURE_NOT_DISMISSED = 592,
  ATTACHMENT_RTK_COM_FAILURE = 422,
  ATTACHMENT_SPEAKERMIC_LOW_VOLUME = 440,
  ATTACHMENT_CELLULAR_MODEM_UNRESPONSIVE = 538,
  ATTACHMENT_CELLULAR_MODEM_IN_BOOTLOADER = 539,
  ATTACHMENT_CELLULAR_MODEM_ENABLED_BUT_DISCONNECTED = 540,
  ATTACHMENT_CELLULAR_MODEM_DISABLED_BUT_CONNECTED = 541,
  ATTACHMENT_CELLULAR_MODEM_CORRUPTED = 542,
  ATTACHMENT_CELLULAR_MODEM_NO_SIM_CONFIG = 543,
  ATTACHMENT_CELLULAR_MODEM_NO_SIM_CONFIG_NOT_DISMISSED = 544,
  ATTACHMENT_CELLULAR_MODEM_NO_RX = 545,
  ATTACHMENT_CELLULAR_MODEM_NO_SIM_INSERTED = 546,
  ATTACHMENT_SPOTLIGHT_TWO_SPOTLIGHTS_UNSUPPORTED = 417,
  ATTACHMENT_INVALID_COMBINATION = 427,
  RID_TX_FAILURE = 380,
  PINE_HIGH_INTERFERENCE = 435,
  PINE_SU_PKTS_IN_OFDMA = 436,
  PINE_CLOSE_INTERFERENCE = 455,
  PINE_PERSISTENT_HIGH_INTERFERENCE = 454,
  PINE_RADAR_DETECTED = 548,
  PINE_RADAR_DETECTED_NOT_DISMISSED = 549,
  NCPG_SAVE_IN_PROGRESS = 382,
  MISSION_CONDUCTOR_DISABLE_PILOTSHIP = 383,
  GROUND_AVOIDANCE_ACTIVE = 387,
  GPS_SPOOFED = 411,
  GPS_INVALID_TIME = 580,
  EVENT_LOOP_FD_OVERFLOW = 412,
  MICROHARD_DCS_JAMMING_FAULT = 414,
  BATTERY_NOT_ARMED = 418,
  VEHICLE_TOO_HOT_CRITICAL_FINAL = 419,
  IMU_NEAR_SATURATION = 424,
  ATTI_TAKEOFF_AWAITING_USER_INPUT = 426,
  VEHICLE_CLOCK_STALE = 430,
  VEHICLE_CLOCK_STALE_NOT_DISMISSED = 431,
  FLIR_FIRMWARE_UPDATE_IN_PROGRESS = 433,
  FLIR_FIRMWARE_VERSION_MISMATCH = 434,
  NAV_FRAME_UNRELIABLE = 443,
  MISSION_NOT_READY_FOR_TAKEOFF = 444,
  UNEXPECTED_OBSTACLES_HIGH_SPEED = 446,
  APPROACHING_GEOAWARENESS_ZONE = 447,
  ENTERED_GEOAWARENESS_ZONE = 448,
  GEOAWARENESS_UNAVAILABLE_FILE = 449,
  GEOAWARENESS_UNAVAILABLE_GPS = 450,
  YIELD_FOR_NEARBY_DRONES = 451,
  YIELD_FOR_NEARBY_DRONES_NOT_DISMISSED = 484,
  AWAITING_CLOUD_CONFIG_UPDATE = 452,
  UPDATED_CLOUD_CONFIG_REBOOT_REQUIRED = 526,
  SETUP_FLIGHT_INCOMPLETE = 453,
  SETUP_FLIGHT_INCOMPLETE_CLOUD = 569,
  SETUP_FLIGHT_IN_PROGRESS = 460,
  AWAITING_SETUP_FLIGHT_RESULTS = 461,
  SETUP_FLIGHT_FAILED = 462,
  SETUP_FLIGHT_FAILED_TAG_SET_VERIFICATION = 463,
  SETUP_FLIGHT_FAILED_GPS = 464,
  SETUP_FLIGHT_FAILED_GOTO_WAYPOINT = 465,
  DRONE_FAR_FROM_DOCK = 469,
  DOCK_HEADING_MISMATCH = 529,
  INACCURATE_DOCK_LANDING = 456,
  CELLULAR_MODEM_UNRESPONSIVE = 457,
  CELLULAR_MODEM_IN_BOOTLOADER = 458,
  CELLULAR_MODEM_ENABLED_BUT_DISCONNECTED = 472,
  CELLULAR_MODEM_DISABLED_BUT_CONNECTED = 473,
  CELLULAR_MODEM_AWAITING_ENUMERATION = 475,
  CELLULAR_MODEM_CORRUPTED = 480,
  CELLULAR_MODEM_NO_SIM_CONFIG = 487,
  CELLULAR_MODEM_NO_SIM_CONFIG_NOT_DISMISSED = 492,
  CELLULAR_MODEM_NO_RX = 489,
  CELLULAR_MODEM_NO_SIM_INSERTED = 519,
  ESC_TELEMETRY_MISSING = 466,
  ROI_STREAM_STOPPED = 467,
  SOFTWARE_UPDATE_SUCCEEDED_REBOOT = 470,
  SOFTWARE_UPDATE_FAILED_REBOOT = 471,
  FLIGHT_DECK_DATABASE_MALFORMED = 474,
  WIFI_DFS_CAC_IN_PROGRESS = 479,
  NCR_UNRELIABLE = 481,
  NCR_FULL_MAPPING_UNRELIABLE = 482,
  NCR_ONLINE_UNRELIABLE = 483,
  MOTOR_ICE_DETECTED = 486,
  COLD_WEATHER_ICING_RISK = 596,
  FLIR_USB_NOT_CONNECTED = 488,
  RETURN_TO_DOCK_UNAVAILABLE = 490,
  CUSTOMER_NFS_MOUNT_FAILED = 491,
  PATHFINDER_FAILED_TO_COMPUTE_PATH = 493,
  PATHFINDER_FAILED_TERRAIN_QUERY = 494,
  PATHFINDER_FAILED_GPS_LINEARIZATION = 495,
  PATHFINDER_FAILED_OBSTACLE_AVOIDANCE_DISABLED = 496,
  PATHFINDER_FAILED_GROUND_TAKEOFF = 503,
  PATHFINDER_FAILED_GPS_QUALITY_INSUFFICIENT = 520,
  PATHFINDER_FAILED_ALTITUDES_INCONSISTENT = 556,
  PATHFINDER_FAILED_ESTIMATION_TASK = 585,
  PATHFINDER_UNAVAILABLE_MISSING_SITE_DATA = 497,
  PATHFINDER_UNAVAILABLE_MISSING_EXTERNAL_DATA = 498,
  PATHFINDER_UNAVAILABLE_OBSTACLE_AVOIDANCE_DISABLED = 499,
  PATHFINDER_UNAVAILABLE_GROUND_TAKEOFF = 500,
  PATHFINDER_UNAVAILABLE_FRONT_UNRELIABLE = 547,
  PATHFINDER_UNAVAILABLE_ALTITUDES_INCONSISTENT = 557,
  PATHFINDER_UNAVAILABLE_UNSUPPORTED_VERSION = 574,
  PATHFINDER_DEGRADED_OUTSIDE_RANGE = 606,
  DOCK_CLIENT_UNINITIALIZED = 501,
  DOCK_HEIGHT_UNAVAILABLE = 502,
  VIO_INSUFFICIENT_STATIC_TIME_BEFORE_TAKEOFF = 504,
  NFS_MOUNT_FAILED = 505,
  RID_OPERATOR_ID_FAULT = 516,
  BATTERY_NOT_DOCK_COMPATIBLE = 517,
  VEHICLE_BLOWING_AWAY = 518,
  EXT4_CORRUPTION = 521,
  LOST_CLOUD_CONNECTION = 527,
  CLOUD_UNREACHABLE = 559,
  INTERNET_CONNECTION_DEGRADED = 575,
  LINKED_DEVICE_CONNECTION_DEGRADED = 576,
  SIMULATOR_SET_CLOUD_TAKEOFF_POINT_ALTITUDE_FAILED = 530,
  MEDIA_SYNC_ENCRYPTED_DATA_BLOCKED_FROM_UPLOAD = 531,
  PROCEED_WITH_DRONES_NEARBY = 532,
  PROCEED_WITH_DRONES_NEARBY_NOT_DISMISSED = 533,
  EXCESSIVE_MOTOR_VIBE_IN_FLIGHT = 552,
  CONFIGURING_MISSION_ENV = 553,
  STUCK_ON_OTHER_DRONES = 558,
  TURTLE_MODE_ACTIVE = 560,
  BATTERY_POWER_LIMIT_FORCES_LANDING = 561,
  BATTERY_FRETTING_CRITICAL = 563,
  WAIT_FOR_PRECISE_PREP = 565,
  WAIT_FOR_PRECISE_LAUNCH = 566,
  ENCRYPTION_KEY_ALREADY_PROVISIONED = 567,
  ENCRYPTION_CLOUD_KEY_UNLOCK_TOKEN_EXPIRED = 568,
  YUBIKEY_COMMUNICATION_ERROR = 593,
  ENCRYPTION_UNLOCK_IN_PROGRESS = 599,
  VEHICLE_GROUNDED_BY_CLOUD_CONFIG = 570,
  BATTERY_SUSPENDED_VIA_DOCK = 572,
  DOCK_ROOF_OPEN_TIMEOUT = 573,
  INSUFFICIENT_RETURN_ENERGY_WITH_NIGHTSENSE = 577,
  NIGHTSENSE_TOO_HOT = 582,
  FLIGHT_ENVELOPE_LIMITING_POWER = 604,
  FOLLOWING_WITHOUT_OA = 605,
  BATTERY_NOT_LATCHED = 607,
  IMU_BIAS_TOO_HIGH = 609,
  IMU_SATURATING = 610,
  BLACKOUT_MODE_SWITCH_NOT_POSSIBLE = 611,
  RAINING_WITH_DROPPER = 612,
  RAINING_WITH_DROPPER_NOT_DISMISSED = 613,
  SCENARIO_SIM_FAILED_TO_LOAD_SCENARIO = 614,
  ADSB_REGULATORY_MANAGER_ACTIVE = 615,
  ADSB_REGULATORY_MANAGER_RESPONDING = 616,
  MAX_NUM_FAULTS = 620,
}

export class fault_t extends LcmEnumMsg {
  public static override option_t = option_t;
  private static _hash = Long.fromString("11999453122282051735", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (fault_t._packed_fingerprint === undefined) {
      fault_t._packed_fingerprint = fault_t._get_hash_recursive([]);
    }
    return fault_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(fault_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = fault_t._hash;
    tmp_hash = tmp_hash.shl(1).add(tmp_hash.shru(63));
    return tmp_hash;
  }

  public override decode(array: Uint8Array): fault_t {
    const decoder = new Decoder(
      new DataView(array.buffer, array.byteOffset, array.byteLength)
    );
    const hash = decoder.decode_hash();
    if (!hash.equals(fault_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, fault_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  // Recursively decode a message with the supplied decoder.
  public override decode_one(decoder: Decoder): fault_t {
    this.value = decoder.decode_int32_t();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    return 4;
  }

  public override encode(): ArrayBufferLike {
    const total_size = this._get_encoded_size();
    const encoder = new Encoder(total_size);
    this.encode_one(encoder);
    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int32_t(this.value);
  }

  // static constructors
  static get INVALID() {
    return new fault_t(option_t.INVALID);
  }
  static get TASK_QUEUE_RUNNING() {
    return new fault_t(option_t.TASK_QUEUE_RUNNING);
  }
  static get LIGHTING_ATTACHMENT_DISCONNECTED() {
    return new fault_t(option_t.LIGHTING_ATTACHMENT_DISCONNECTED);
  }
  static get BATTERY_LOW_LAND() {
    return new fault_t(option_t.BATTERY_LOW_LAND);
  }
  static get PLANNER_UNRELIABLE() {
    return new fault_t(option_t.PLANNER_UNRELIABLE);
  }
  static get POSE_POLISHER_UNRELIABLE() {
    return new fault_t(option_t.POSE_POLISHER_UNRELIABLE);
  }
  static get NIGHT_MODE_HEADING_UNINITIALIZED() {
    return new fault_t(option_t.NIGHT_MODE_HEADING_UNINITIALIZED);
  }
  static get VIO_UNRELIABLE() {
    return new fault_t(option_t.VIO_UNRELIABLE);
  }
  static get VIO_DEGRADED() {
    return new fault_t(option_t.VIO_DEGRADED);
  }
  static get VIO_VERY_DEGRADED() {
    return new fault_t(option_t.VIO_VERY_DEGRADED);
  }
  static get GPS_DEGRADED() {
    return new fault_t(option_t.GPS_DEGRADED);
  }
  static get VIO_UNRELIABLE_REDUCED_OBSTACLES() {
    return new fault_t(option_t.VIO_UNRELIABLE_REDUCED_OBSTACLES);
  }
  static get VIO_STATIC_INITIALIZATION_FAILED() {
    return new fault_t(option_t.VIO_STATIC_INITIALIZATION_FAILED);
  }
  static get POSE_SOURCE_DEGRADED() {
    return new fault_t(option_t.POSE_SOURCE_DEGRADED);
  }
  static get VEHICLE_UNCALIBRATED() {
    return new fault_t(option_t.VEHICLE_UNCALIBRATED);
  }
  static get VOXELS_UNRELIABLE() {
    return new fault_t(option_t.VOXELS_UNRELIABLE);
  }
  static get STEREO_UNRELIABLE() {
    return new fault_t(option_t.STEREO_UNRELIABLE);
  }
  static get SUBJECT_UNRELIABLE() {
    return new fault_t(option_t.SUBJECT_UNRELIABLE);
  }
  static get IGNORE_OBSTACLES() {
    return new fault_t(option_t.IGNORE_OBSTACLES);
  }
  static get IGNORE_SOME_FAULTS() {
    return new fault_t(option_t.IGNORE_SOME_FAULTS);
  }
  static get LOGGING_SPACE_LOW() {
    return new fault_t(option_t.LOGGING_SPACE_LOW);
  }
  static get LOGGING_SPACE_CRITICAL() {
    return new fault_t(option_t.LOGGING_SPACE_CRITICAL);
  }
  static get LOGGING_SPACE_LOW_BETA() {
    return new fault_t(option_t.LOGGING_SPACE_LOW_BETA);
  }
  static get LOGGING_SPACE_LOW_NOT_DISMISSED() {
    return new fault_t(option_t.LOGGING_SPACE_LOW_NOT_DISMISSED);
  }
  static get EMMC_SPACE_LOW() {
    return new fault_t(option_t.EMMC_SPACE_LOW);
  }
  static get EMMC_SPACE_LOW_QCU() {
    return new fault_t(option_t.EMMC_SPACE_LOW_QCU);
  }
  static get EMMC_SPACE_CRITICAL() {
    return new fault_t(option_t.EMMC_SPACE_CRITICAL);
  }
  static get EMMC_SPACE_CRITICAL_QCU() {
    return new fault_t(option_t.EMMC_SPACE_CRITICAL_QCU);
  }
  static get FLIGHT_LOGGER_UNRELIABLE() {
    return new fault_t(option_t.FLIGHT_LOGGER_UNRELIABLE);
  }
  static get MOTOR_NOT_SPINNING() {
    return new fault_t(option_t.MOTOR_NOT_SPINNING);
  }
  static get LOST_RC() {
    return new fault_t(option_t.LOST_RC);
  }
  static get SUBJECT_CAMERA_UNRELIABLE() {
    return new fault_t(option_t.SUBJECT_CAMERA_UNRELIABLE);
  }
  static get SUBJECT_CAMERA_STOPPED() {
    return new fault_t(option_t.SUBJECT_CAMERA_STOPPED);
  }
  static get BASE_PROCESSES_STOPPED() {
    return new fault_t(option_t.BASE_PROCESSES_STOPPED);
  }
  static get FLIGHT_PROCESSES_STOPPED() {
    return new fault_t(option_t.FLIGHT_PROCESSES_STOPPED);
  }
  static get NOT_ARMED() {
    return new fault_t(option_t.NOT_ARMED);
  }
  static get MOTOR_SYNC_LOST() {
    return new fault_t(option_t.MOTOR_SYNC_LOST);
  }
  static get MISSING_IMAGES() {
    return new fault_t(option_t.MISSING_IMAGES);
  }
  static get VEHICLE_STUCK() {
    return new fault_t(option_t.VEHICLE_STUCK);
  }
  static get IMU_DRIVER_UNRELIABLE() {
    return new fault_t(option_t.IMU_DRIVER_UNRELIABLE);
  }
  static get VEHICLE_IMU_SOURCE_NOT_PRIMARY() {
    return new fault_t(option_t.VEHICLE_IMU_SOURCE_NOT_PRIMARY);
  }
  static get BARO_DRIVER_UNRELIABLE() {
    return new fault_t(option_t.BARO_DRIVER_UNRELIABLE);
  }
  static get NAV_CAMERAS_UNRELIABLE() {
    return new fault_t(option_t.NAV_CAMERAS_UNRELIABLE);
  }
  static get AMBARELLA_DRIVER_UNRELIABLE() {
    return new fault_t(option_t.AMBARELLA_DRIVER_UNRELIABLE);
  }
  static get SKILLS_UNRELIABLE() {
    return new fault_t(option_t.SKILLS_UNRELIABLE);
  }
  static get HAND_TAKEOFF_OBSTRUCTED() {
    return new fault_t(option_t.HAND_TAKEOFF_OBSTRUCTED);
  }
  static get HAND_TAKEOFF_SHALLOW_OBSTRUCTED() {
    return new fault_t(option_t.HAND_TAKEOFF_SHALLOW_OBSTRUCTED);
  }
  static get HAND_TAKEOFF_VERTICAL_OBSTRUCTED() {
    return new fault_t(option_t.HAND_TAKEOFF_VERTICAL_OBSTRUCTED);
  }
  static get BAD_CPU_FREQUENCY() {
    return new fault_t(option_t.BAD_CPU_FREQUENCY);
  }
  static get BAD_GPU_FREQUENCY() {
    return new fault_t(option_t.BAD_GPU_FREQUENCY);
  }
  static get HIGH_WINDS_WARN() {
    return new fault_t(option_t.HIGH_WINDS_WARN);
  }
  static get HIGH_WINDS_SEVERE() {
    return new fault_t(option_t.HIGH_WINDS_SEVERE);
  }
  static get HIGH_WINDS_LAND() {
    return new fault_t(option_t.HIGH_WINDS_LAND);
  }
  static get DIRTY_CAMERAS_LOW() {
    return new fault_t(option_t.DIRTY_CAMERAS_LOW);
  }
  static get DIRTY_CAMERAS_HIGH() {
    return new fault_t(option_t.DIRTY_CAMERAS_HIGH);
  }
  static get COLLISION() {
    return new fault_t(option_t.COLLISION);
  }
  static get MOTOR_HOT_WARNING() {
    return new fault_t(option_t.MOTOR_HOT_WARNING);
  }
  static get MOTOR_HOT_CRITICAL() {
    return new fault_t(option_t.MOTOR_HOT_CRITICAL);
  }
  static get PLANNER_STATE_UNRELIABLE() {
    return new fault_t(option_t.PLANNER_STATE_UNRELIABLE);
  }
  static get EXECUTIVE_MANAGER_UNRELIABLE() {
    return new fault_t(option_t.EXECUTIVE_MANAGER_UNRELIABLE);
  }
  static get TASK_QUEUE_RUNNING_UNINTERRUPTIBLE() {
    return new fault_t(option_t.TASK_QUEUE_RUNNING_UNINTERRUPTIBLE);
  }
  static get TASK_QUEUE_RUNNING_INTERRUPTIBLE() {
    return new fault_t(option_t.TASK_QUEUE_RUNNING_INTERRUPTIBLE);
  }
  static get AMBARELLA_SD_STILL_MOUNTED() {
    return new fault_t(option_t.AMBARELLA_SD_STILL_MOUNTED);
  }
  static get BATTERY_TOO_COLD() {
    return new fault_t(option_t.BATTERY_TOO_COLD);
  }
  static get BATTERY_NEEDS_HEATING() {
    return new fault_t(option_t.BATTERY_NEEDS_HEATING);
  }
  static get BATTERY_HEATER_ON() {
    return new fault_t(option_t.BATTERY_HEATER_ON);
  }
  static get BATTERY_TOO_COLD_BUT_IS_HEATING() {
    return new fault_t(option_t.BATTERY_TOO_COLD_BUT_IS_HEATING);
  }
  static get BATTERY_TOO_COLD_LIMP_OK() {
    return new fault_t(option_t.BATTERY_TOO_COLD_LIMP_OK);
  }
  static get USBC_IN_USE() {
    return new fault_t(option_t.USBC_IN_USE);
  }
  static get USBC_SECURITY_KEY_IN_USE() {
    return new fault_t(option_t.USBC_SECURITY_KEY_IN_USE);
  }
  static get CPU_TOO_HIGH() {
    return new fault_t(option_t.CPU_TOO_HIGH);
  }
  static get GPU_TOO_HIGH() {
    return new fault_t(option_t.GPU_TOO_HIGH);
  }
  static get VEHICLE_TOO_HOT_CRITICAL() {
    return new fault_t(option_t.VEHICLE_TOO_HOT_CRITICAL);
  }
  static get VEHICLE_TOO_HOT_WARNING() {
    return new fault_t(option_t.VEHICLE_TOO_HOT_WARNING);
  }
  static get AMBARELLA_TOO_HOT() {
    return new fault_t(option_t.AMBARELLA_TOO_HOT);
  }
  static get GPS_UNRELIABLE() {
    return new fault_t(option_t.GPS_UNRELIABLE);
  }
  static get GPS_AWAITING_HEADING() {
    return new fault_t(option_t.GPS_AWAITING_HEADING);
  }
  static get PRE_FLIGHT_TASKS_REQUIRED() {
    return new fault_t(option_t.PRE_FLIGHT_TASKS_REQUIRED);
  }
  static get ENCRYPTION_BLOCKING_PRE_FLIGHT_TASKS() {
    return new fault_t(option_t.ENCRYPTION_BLOCKING_PRE_FLIGHT_TASKS);
  }
  static get ENCRYPTION_BLOCKING_PRE_FLIGHT_TASKS_NOT_DISMISSED() {
    return new fault_t(option_t.ENCRYPTION_BLOCKING_PRE_FLIGHT_TASKS_NOT_DISMISSED);
  }
  static get GAP_TOO_SMALL() {
    return new fault_t(option_t.GAP_TOO_SMALL);
  }
  static get HAND_TAKEOFF_DANGEROUS() {
    return new fault_t(option_t.HAND_TAKEOFF_DANGEROUS);
  }
  static get ENVIRONMENT_DANGEROUS() {
    return new fault_t(option_t.ENVIRONMENT_DANGEROUS);
  }
  static get HAND_TAKEOFF_DANGEROUS_HIGH_GRADIENT() {
    return new fault_t(option_t.HAND_TAKEOFF_DANGEROUS_HIGH_GRADIENT);
  }
  static get HAND_TAKEOFF_DANGEROUS_DARK() {
    return new fault_t(option_t.HAND_TAKEOFF_DANGEROUS_DARK);
  }
  static get MOTOR_FLASH_IN_PROGRESS() {
    return new fault_t(option_t.MOTOR_FLASH_IN_PROGRESS);
  }
  static get MOTOR_FLASH_FAILURE() {
    return new fault_t(option_t.MOTOR_FLASH_FAILURE);
  }
  static get TEGRA_STATE_ESTIMATION_FAILED() {
    return new fault_t(option_t.TEGRA_STATE_ESTIMATION_FAILED);
  }
  static get EMERGENCY_LANDING_AIRHAWK_ONLY() {
    return new fault_t(option_t.EMERGENCY_LANDING_AIRHAWK_ONLY);
  }
  static get EMERGENCY_LANDING_TEGRA_POSES() {
    return new fault_t(option_t.EMERGENCY_LANDING_TEGRA_POSES);
  }
  static get VELOCITY_CONTROL_DIVERGED() {
    return new fault_t(option_t.VELOCITY_CONTROL_DIVERGED);
  }
  static get POSITION_CONTROL_DIVERGED() {
    return new fault_t(option_t.POSITION_CONTROL_DIVERGED);
  }
  static get YAW_CONTROL_DIVERGED() {
    return new fault_t(option_t.YAW_CONTROL_DIVERGED);
  }
  static get PILOT_NOT_READY_TO_FLY() {
    return new fault_t(option_t.PILOT_NOT_READY_TO_FLY);
  }
  static get PILOT_WAITING_TO_FLY() {
    return new fault_t(option_t.PILOT_WAITING_TO_FLY);
  }
  static get PILOT_WAITING_TO_BROWSE() {
    return new fault_t(option_t.PILOT_WAITING_TO_BROWSE);
  }
  static get GPS_UNRELIABLE_HOVER() {
    return new fault_t(option_t.GPS_UNRELIABLE_HOVER);
  }
  static get TEGRA_STATE_ESTIMATION_HOVER() {
    return new fault_t(option_t.TEGRA_STATE_ESTIMATION_HOVER);
  }
  static get MOTOR_QUALITY() {
    return new fault_t(option_t.MOTOR_QUALITY);
  }
  static get GIMBAL_IMU_UNRELIABLE() {
    return new fault_t(option_t.GIMBAL_IMU_UNRELIABLE);
  }
  static get GIMBAL_UNCALIBRATED() {
    return new fault_t(option_t.GIMBAL_UNCALIBRATED);
  }
  static get GIMBAL_CONTROLLER_UNRELIABLE() {
    return new fault_t(option_t.GIMBAL_CONTROLLER_UNRELIABLE);
  }
  static get GIMBAL_ENCODER_UNRELIABLE() {
    return new fault_t(option_t.GIMBAL_ENCODER_UNRELIABLE);
  }
  static get GIMBAL_ESTIMATOR_FAILED() {
    return new fault_t(option_t.GIMBAL_ESTIMATOR_FAILED);
  }
  static get GIMBAL_ESTIMATOR_MISSING_IMU_DATA() {
    return new fault_t(option_t.GIMBAL_ESTIMATOR_MISSING_IMU_DATA);
  }
  static get GIMBAL_ESTIMATOR_ACCEL_NORM_TOO_HIGH() {
    return new fault_t(option_t.GIMBAL_ESTIMATOR_ACCEL_NORM_TOO_HIGH);
  }
  static get GIMBAL_ESTIMATOR_NEEDS_INITIALIZER() {
    return new fault_t(option_t.GIMBAL_ESTIMATOR_NEEDS_INITIALIZER);
  }
  static get GIMBAL_ESTIMATOR_INSUFFICIENT_TIME() {
    return new fault_t(option_t.GIMBAL_ESTIMATOR_INSUFFICIENT_TIME);
  }
  static get GIMBAL_ESTIMATOR_COMPUTING_MOTOR_ANGLES() {
    return new fault_t(option_t.GIMBAL_ESTIMATOR_COMPUTING_MOTOR_ANGLES);
  }
  static get GIMBAL_UNRELIABLE() {
    return new fault_t(option_t.GIMBAL_UNRELIABLE);
  }
  static get FALCON_HOOD() {
    return new fault_t(option_t.FALCON_HOOD);
  }
  static get GIMBAL_OBSTRUCTED() {
    return new fault_t(option_t.GIMBAL_OBSTRUCTED);
  }
  static get GIMBAL_FREAK_OUT() {
    return new fault_t(option_t.GIMBAL_FREAK_OUT);
  }
  static get GIMBAL_EMBEDDED_ESTIMATOR_NOT_INITIALIZED() {
    return new fault_t(option_t.GIMBAL_EMBEDDED_ESTIMATOR_NOT_INITIALIZED);
  }
  static get GIMBAL_EMBEDDED_ESTIMATOR_STALE_REFERENCE() {
    return new fault_t(option_t.GIMBAL_EMBEDDED_ESTIMATOR_STALE_REFERENCE);
  }
  static get GIMBAL_VISION_ESTIMATOR_UNRELIABLE() {
    return new fault_t(option_t.GIMBAL_VISION_ESTIMATOR_UNRELIABLE);
  }
  static get GIMBAL_FLASHLIGHT_TOO_HOT() {
    return new fault_t(option_t.GIMBAL_FLASHLIGHT_TOO_HOT);
  }
  static get GIMBAL_CONFIG_NOT_YET_FINALIZED() {
    return new fault_t(option_t.GIMBAL_CONFIG_NOT_YET_FINALIZED);
  }
  static get EXTERNAL_TORQUE_NORM_TOO_HIGH() {
    return new fault_t(option_t.EXTERNAL_TORQUE_NORM_TOO_HIGH);
  }
  static get ROTOR_SPEED_CONTROL_DIVERGED() {
    return new fault_t(option_t.ROTOR_SPEED_CONTROL_DIVERGED);
  }
  static get AUTOEXPOSURE_HAS_NOT_CONVERGED() {
    return new fault_t(option_t.AUTOEXPOSURE_HAS_NOT_CONVERGED);
  }
  static get MEDIA_TRANSCODE_POSSIBLE() {
    return new fault_t(option_t.MEDIA_TRANSCODE_POSSIBLE);
  }
  static get NOT_ACHIEVING_MOVEMENT_COMMAND() {
    return new fault_t(option_t.NOT_ACHIEVING_MOVEMENT_COMMAND);
  }
  static get CONTACT() {
    return new fault_t(option_t.CONTACT);
  }
  static get BATTERY_TOO_HOT_WARNING() {
    return new fault_t(option_t.BATTERY_TOO_HOT_WARNING);
  }
  static get BATTERY_TOO_HOT_CRITICAL() {
    return new fault_t(option_t.BATTERY_TOO_HOT_CRITICAL);
  }
  static get BATTERY_NOT_CHARGING_TOO_HOT() {
    return new fault_t(option_t.BATTERY_NOT_CHARGING_TOO_HOT);
  }
  static get BATTERY_NOT_CHARGING_TOO_COLD() {
    return new fault_t(option_t.BATTERY_NOT_CHARGING_TOO_COLD);
  }
  static get MEMORY_LOW() {
    return new fault_t(option_t.MEMORY_LOW);
  }
  static get TOO_MANY_PAGE_FAULTS() {
    return new fault_t(option_t.TOO_MANY_PAGE_FAULTS);
  }
  static get BATTERY_GAS_GAUGE_ERROR() {
    return new fault_t(option_t.BATTERY_GAS_GAUGE_ERROR);
  }
  static get BATTERY_GAS_GAUGE_VERSION_MISMATCH() {
    return new fault_t(option_t.BATTERY_GAS_GAUGE_VERSION_MISMATCH);
  }
  static get VEHICLE_IN_HAND() {
    return new fault_t(option_t.VEHICLE_IN_HAND);
  }
  static get FLIGHT_LOGS_NOT_MOUNTED() {
    return new fault_t(option_t.FLIGHT_LOGS_NOT_MOUNTED);
  }
  static get MOTOR_SPINUP_FAILURE() {
    return new fault_t(option_t.MOTOR_SPINUP_FAILURE);
  }
  static get MEDIA_SD_MISSING() {
    return new fault_t(option_t.MEDIA_SD_MISSING);
  }
  static get MEDIA_SD_UNFORMATTED() {
    return new fault_t(option_t.MEDIA_SD_UNFORMATTED);
  }
  static get MEDIA_SD_CORRUPTED() {
    return new fault_t(option_t.MEDIA_SD_CORRUPTED);
  }
  static get MEDIA_SD_SLOW() {
    return new fault_t(option_t.MEDIA_SD_SLOW);
  }
  static get MEDIA_SPACE_LOW() {
    return new fault_t(option_t.MEDIA_SPACE_LOW);
  }
  static get MEDIA_SPACE_CRITICAL() {
    return new fault_t(option_t.MEDIA_SPACE_CRITICAL);
  }
  static get MEDIA_SPACE_FULL() {
    return new fault_t(option_t.MEDIA_SPACE_FULL);
  }
  static get INSUFFICIENT_MEDIA_SD_STORAGE_FOR_MISSION() {
    return new fault_t(option_t.INSUFFICIENT_MEDIA_SD_STORAGE_FOR_MISSION);
  }
  static get MEDIA_SD_NEEDS_TO_AUTODELETE() {
    return new fault_t(option_t.MEDIA_SD_NEEDS_TO_AUTODELETE);
  }
  static get MEDIA_SD_WRONG_ENCRYPTION_KEY() {
    return new fault_t(option_t.MEDIA_SD_WRONG_ENCRYPTION_KEY);
  }
  static get MEDIA_SD_MISSING_NOT_DISMISSED() {
    return new fault_t(option_t.MEDIA_SD_MISSING_NOT_DISMISSED);
  }
  static get MEDIA_SD_UNFORMATTED_NOT_DISMISSED() {
    return new fault_t(option_t.MEDIA_SD_UNFORMATTED_NOT_DISMISSED);
  }
  static get MEDIA_SD_CORRUPTED_NOT_DISMISSED() {
    return new fault_t(option_t.MEDIA_SD_CORRUPTED_NOT_DISMISSED);
  }
  static get MEDIA_SD_SLOW_NOT_DISMISSED() {
    return new fault_t(option_t.MEDIA_SD_SLOW_NOT_DISMISSED);
  }
  static get MEDIA_SPACE_LOW_NOT_DISMISSED() {
    return new fault_t(option_t.MEDIA_SPACE_LOW_NOT_DISMISSED);
  }
  static get MEDIA_SD_LOADING_DTED_FILES() {
    return new fault_t(option_t.MEDIA_SD_LOADING_DTED_FILES);
  }
  static get LOGGING_SD_MISSING() {
    return new fault_t(option_t.LOGGING_SD_MISSING);
  }
  static get LOGGING_SD_MISSING_NOT_DISMISSED() {
    return new fault_t(option_t.LOGGING_SD_MISSING_NOT_DISMISSED);
  }
  static get LOGGING_SD_WRONG_FILESYSTEM() {
    return new fault_t(option_t.LOGGING_SD_WRONG_FILESYSTEM);
  }
  static get LOGGING_SD_WRONG_FILESYSTEM_NOT_DISMISSED() {
    return new fault_t(option_t.LOGGING_SD_WRONG_FILESYSTEM_NOT_DISMISSED);
  }
  static get LOGGING_SD_WRONG_FILESYSTEM_IN_USE() {
    return new fault_t(option_t.LOGGING_SD_WRONG_FILESYSTEM_IN_USE);
  }
  static get LOGGING_SD_SLOW() {
    return new fault_t(option_t.LOGGING_SD_SLOW);
  }
  static get LOGGING_SD_NOT_ENCRYPTED() {
    return new fault_t(option_t.LOGGING_SD_NOT_ENCRYPTED);
  }
  static get LOGGING_SD_LOCKED() {
    return new fault_t(option_t.LOGGING_SD_LOCKED);
  }
  static get LOGGING_SD_SECURITY_KEY_REQUIRED() {
    return new fault_t(option_t.LOGGING_SD_SECURITY_KEY_REQUIRED);
  }
  static get LOGGING_SD_SECURITY_TOKEN_REQUIRED() {
    return new fault_t(option_t.LOGGING_SD_SECURITY_TOKEN_REQUIRED);
  }
  static get LOGGING_SD_SECURITY_ACTIVATION_IN_PROGRESS() {
    return new fault_t(option_t.LOGGING_SD_SECURITY_ACTIVATION_IN_PROGRESS);
  }
  static get LOGGING_SD_SECURITY_ACTIVATION_FAILED() {
    return new fault_t(option_t.LOGGING_SD_SECURITY_ACTIVATION_FAILED);
  }
  static get LOGGING_SD_NOT_MOUNTED() {
    return new fault_t(option_t.LOGGING_SD_NOT_MOUNTED);
  }
  static get BATTERY_CRITICAL() {
    return new fault_t(option_t.BATTERY_CRITICAL);
  }
  static get BATTERY_CRITICAL_PILOT_WARNING() {
    return new fault_t(option_t.BATTERY_CRITICAL_PILOT_WARNING);
  }
  static get BATTERY_CRITICAL_FORCE_FAST_DESCENT() {
    return new fault_t(option_t.BATTERY_CRITICAL_FORCE_FAST_DESCENT);
  }
  static get BATTERY_LOW() {
    return new fault_t(option_t.BATTERY_LOW);
  }
  static get BATTERY_LOW_RETURN_PILOT_WARNING() {
    return new fault_t(option_t.BATTERY_LOW_RETURN_PILOT_WARNING);
  }
  static get BATTERY_LOW_RETURN() {
    return new fault_t(option_t.BATTERY_LOW_RETURN);
  }
  static get BATTERY_LOW_RETURN_TO_DOCK() {
    return new fault_t(option_t.BATTERY_LOW_RETURN_TO_DOCK);
  }
  static get BATTERY_LOW_RETURN_TO_LOST_CONNECTION() {
    return new fault_t(option_t.BATTERY_LOW_RETURN_TO_LOST_CONNECTION);
  }
  static get BATTERY_LOW_SAFE_LANDING_UNREACHABLE() {
    return new fault_t(option_t.BATTERY_LOW_SAFE_LANDING_UNREACHABLE);
  }
  static get BATTERY_LOW_DISABLE_AUTONOMOUS() {
    return new fault_t(option_t.BATTERY_LOW_DISABLE_AUTONOMOUS);
  }
  static get BATTERY_VOLTAGE_IMBALANCE() {
    return new fault_t(option_t.BATTERY_VOLTAGE_IMBALANCE);
  }
  static get BATTERY_VOLTAGE_IMBALANCE_LAND() {
    return new fault_t(option_t.BATTERY_VOLTAGE_IMBALANCE_LAND);
  }
  static get BATTERY_HIGH_CURRENT() {
    return new fault_t(option_t.BATTERY_HIGH_CURRENT);
  }
  static get BATTERY_HIGH_CURRENT_CRITICAL() {
    return new fault_t(option_t.BATTERY_HIGH_CURRENT_CRITICAL);
  }
  static get PAGE_ALLOCATION_FAILURE() {
    return new fault_t(option_t.PAGE_ALLOCATION_FAILURE);
  }
  static get LOST_PHONE_COMM_SHORT() {
    return new fault_t(option_t.LOST_PHONE_COMM_SHORT);
  }
  static get LOST_CONNECTION_RETURN() {
    return new fault_t(option_t.LOST_CONNECTION_RETURN);
  }
  static get LOST_CONNECTION_RTH() {
    return new fault_t(option_t.LOST_CONNECTION_RTH);
  }
  static get LOST_CONNECTION_RTD() {
    return new fault_t(option_t.LOST_CONNECTION_RTD);
  }
  static get LOST_CONNECTION_LAND() {
    return new fault_t(option_t.LOST_CONNECTION_LAND);
  }
  static get LOST_CONNECTION_STOP_TRACK() {
    return new fault_t(option_t.LOST_CONNECTION_STOP_TRACK);
  }
  static get PHONE_GPS_QUALITY_INSUFFICIENT() {
    return new fault_t(option_t.PHONE_GPS_QUALITY_INSUFFICIENT);
  }
  static get VEHICLE_GPS_QUALITY_INSUFFICIENT() {
    return new fault_t(option_t.VEHICLE_GPS_QUALITY_INSUFFICIENT);
  }
  static get VEHICLE_GPS_QUALITY_BLOCKING() {
    return new fault_t(option_t.VEHICLE_GPS_QUALITY_BLOCKING);
  }
  static get VEHICLE_GPS_INOPERATIVE() {
    return new fault_t(option_t.VEHICLE_GPS_INOPERATIVE);
  }
  static get BEACON_GPS_QUALITY_BLOCKING() {
    return new fault_t(option_t.BEACON_GPS_QUALITY_BLOCKING);
  }
  static get BEACON_NEEDS_ASSISTNOW() {
    return new fault_t(option_t.BEACON_NEEDS_ASSISTNOW);
  }
  static get BEACON_GPS_QUALITY_INSUFFICIENT() {
    return new fault_t(option_t.BEACON_GPS_QUALITY_INSUFFICIENT);
  }
  static get RID_BEACON_GPS_INOPERATIVE() {
    return new fault_t(option_t.RID_BEACON_GPS_INOPERATIVE);
  }
  static get USER_CAMERA_MODE_SWITCH() {
    return new fault_t(option_t.USER_CAMERA_MODE_SWITCH);
  }
  static get USER_CAMERA_PREVIEW_FORMAT_SWITCH() {
    return new fault_t(option_t.USER_CAMERA_PREVIEW_FORMAT_SWITCH);
  }
  static get UNCANCELLABLE_LANDING() {
    return new fault_t(option_t.UNCANCELLABLE_LANDING);
  }
  static get PILOT_STILL_WAITING_TO_FLY() {
    return new fault_t(option_t.PILOT_STILL_WAITING_TO_FLY);
  }
  static get BEACON_UPDATE_IN_PROGRESS() {
    return new fault_t(option_t.BEACON_UPDATE_IN_PROGRESS);
  }
  static get JOYSTICKS_UPDATE_IN_PROGRESS() {
    return new fault_t(option_t.JOYSTICKS_UPDATE_IN_PROGRESS);
  }
  static get SHOULD_CONNECT_THROUGH_BEACON() {
    return new fault_t(option_t.SHOULD_CONNECT_THROUGH_BEACON);
  }
  static get SHOULD_CONNECT_THROUGH_JOYSTICKS() {
    return new fault_t(option_t.SHOULD_CONNECT_THROUGH_JOYSTICKS);
  }
  static get SHOULD_CONNECT_SKYSTICKS() {
    return new fault_t(option_t.SHOULD_CONNECT_SKYSTICKS);
  }
  static get COMMANDING_BEYOND_SAFETY_HEIGHT() {
    return new fault_t(option_t.COMMANDING_BEYOND_SAFETY_HEIGHT);
  }
  static get PHONE_BATTERY_LOW() {
    return new fault_t(option_t.PHONE_BATTERY_LOW);
  }
  static get PHONE_BATTERY_CRITICAL() {
    return new fault_t(option_t.PHONE_BATTERY_CRITICAL);
  }
  static get BEACON_BATTERY_LOW() {
    return new fault_t(option_t.BEACON_BATTERY_LOW);
  }
  static get BEACON_BATTERY_CRITICAL() {
    return new fault_t(option_t.BEACON_BATTERY_CRITICAL);
  }
  static get JOYSTICKS_BATTERY_LOW() {
    return new fault_t(option_t.JOYSTICKS_BATTERY_LOW);
  }
  static get SKYSTICKS_BATTERY_LOW() {
    return new fault_t(option_t.SKYSTICKS_BATTERY_LOW);
  }
  static get PHONE_BATTERY_LOW_NOT_DISMISSED() {
    return new fault_t(option_t.PHONE_BATTERY_LOW_NOT_DISMISSED);
  }
  static get BEACON_BATTERY_LOW_NOT_DISMISSED() {
    return new fault_t(option_t.BEACON_BATTERY_LOW_NOT_DISMISSED);
  }
  static get JOYSTICKS_BATTERY_LOW_NOT_DISMISSED() {
    return new fault_t(option_t.JOYSTICKS_BATTERY_LOW_NOT_DISMISSED);
  }
  static get SKYSTICKS_BATTERY_LOW_NOT_DISMISSED() {
    return new fault_t(option_t.SKYSTICKS_BATTERY_LOW_NOT_DISMISSED);
  }
  static get FLIGHT_DECK_OUT_OF_SYNC() {
    return new fault_t(option_t.FLIGHT_DECK_OUT_OF_SYNC);
  }
  static get BEACON_UPDATE_READY() {
    return new fault_t(option_t.BEACON_UPDATE_READY);
  }
  static get JOYSTICKS_UPDATE_READY() {
    return new fault_t(option_t.JOYSTICKS_UPDATE_READY);
  }
  static get STUCK_SAFETY_HEIGHT() {
    return new fault_t(option_t.STUCK_SAFETY_HEIGHT);
  }
  static get BEACON_GPS_QUALITY_INSUFFICIENT_TRACKING_PAUSED() {
    return new fault_t(option_t.BEACON_GPS_QUALITY_INSUFFICIENT_TRACKING_PAUSED);
  }
  static get BEACON_GPS_QUALITY_INSUFFICIENT_WITH_VISUAL() {
    return new fault_t(option_t.BEACON_GPS_QUALITY_INSUFFICIENT_WITH_VISUAL);
  }
  static get MIND_THE_GAP() {
    return new fault_t(option_t.MIND_THE_GAP);
  }
  static get MIND_THE_STUCK_SAFETY_HEIGHT() {
    return new fault_t(option_t.MIND_THE_STUCK_SAFETY_HEIGHT);
  }
  static get BATTERY_MESSAGES_UNRELIABLE() {
    return new fault_t(option_t.BATTERY_MESSAGES_UNRELIABLE);
  }
  static get BATTERY_RESET_REQUIRED() {
    return new fault_t(option_t.BATTERY_RESET_REQUIRED);
  }
  static get BATTERY_UPDATE_REQUIRED() {
    return new fault_t(option_t.BATTERY_UPDATE_REQUIRED);
  }
  static get TEGRA_REBOOTED_IN_FLIGHT() {
    return new fault_t(option_t.TEGRA_REBOOTED_IN_FLIGHT);
  }
  static get MAYBE_TEGRA_REBOOTED_IN_FLIGHT() {
    return new fault_t(option_t.MAYBE_TEGRA_REBOOTED_IN_FLIGHT);
  }
  static get BACKTRACK_UNAVAILABLE_TEGRA_REBOOTED() {
    return new fault_t(option_t.BACKTRACK_UNAVAILABLE_TEGRA_REBOOTED);
  }
  static get TOO_DARK_CRITICAL() {
    return new fault_t(option_t.TOO_DARK_CRITICAL);
  }
  static get TOO_DARK_HOVER() {
    return new fault_t(option_t.TOO_DARK_HOVER);
  }
  static get TOO_DARK_WARNING() {
    return new fault_t(option_t.TOO_DARK_WARNING);
  }
  static get TOO_DARK_FOR_VISION() {
    return new fault_t(option_t.TOO_DARK_FOR_VISION);
  }
  static get TOO_DARK_TRY_NIGHT_AUTONOMY() {
    return new fault_t(option_t.TOO_DARK_TRY_NIGHT_AUTONOMY);
  }
  static get TOO_DARK_SOLAR_ANGLE() {
    return new fault_t(option_t.TOO_DARK_SOLAR_ANGLE);
  }
  static get AUTO_SWITCHED_TO_LOW_LIGHT() {
    return new fault_t(option_t.AUTO_SWITCHED_TO_LOW_LIGHT);
  }
  static get TAKEOFF_NEEDS_MOTION() {
    return new fault_t(option_t.TAKEOFF_NEEDS_MOTION);
  }
  static get HAND_WAVE_CAL_NEEDS_STOP_WAVING() {
    return new fault_t(option_t.HAND_WAVE_CAL_NEEDS_STOP_WAVING);
  }
  static get HAND_WAVE_UNAVAILABLE() {
    return new fault_t(option_t.HAND_WAVE_UNAVAILABLE);
  }
  static get TAKEOFF_BLOCKED_BY_POSE_POLISHER() {
    return new fault_t(option_t.TAKEOFF_BLOCKED_BY_POSE_POLISHER);
  }
  static get TAKEOFF_NEEDS_HEALTHY_AEKF() {
    return new fault_t(option_t.TAKEOFF_NEEDS_HEALTHY_AEKF);
  }
  static get NOT_STABLE_FOR_TAKEOFF() {
    return new fault_t(option_t.NOT_STABLE_FOR_TAKEOFF);
  }
  static get TOO_FAST_FOR_TAKEOFF() {
    return new fault_t(option_t.TOO_FAST_FOR_TAKEOFF);
  }
  static get TOO_FAST_FOR_TAKEOFF_NIGHT() {
    return new fault_t(option_t.TOO_FAST_FOR_TAKEOFF_NIGHT);
  }
  static get NOT_STABLE_FOR_TAKEOFF_NIGHT() {
    return new fault_t(option_t.NOT_STABLE_FOR_TAKEOFF_NIGHT);
  }
  static get TOO_FAST_FOR_TAKEOFF_VESSEL() {
    return new fault_t(option_t.TOO_FAST_FOR_TAKEOFF_VESSEL);
  }
  static get NOT_STABLE_FOR_TAKEOFF_VESSEL() {
    return new fault_t(option_t.NOT_STABLE_FOR_TAKEOFF_VESSEL);
  }
  static get TEGRA_REQUIRES_EMERGENCY_LAND() {
    return new fault_t(option_t.TEGRA_REQUIRES_EMERGENCY_LAND);
  }
  static get IS_FIRST_PILOTED_EMERGENCY_LAND() {
    return new fault_t(option_t.IS_FIRST_PILOTED_EMERGENCY_LAND);
  }
  static get IS_PILOTED_EMERGENCY_LAND() {
    return new fault_t(option_t.IS_PILOTED_EMERGENCY_LAND);
  }
  static get COMMANDED_EMERGENCY_LAND() {
    return new fault_t(option_t.COMMANDED_EMERGENCY_LAND);
  }
  static get EMERGENCY_LAND_MOTOR_ARMING_COMMAND() {
    return new fault_t(option_t.EMERGENCY_LAND_MOTOR_ARMING_COMMAND);
  }
  static get EMERGENCY_LAND_LOST_RC_LINK() {
    return new fault_t(option_t.EMERGENCY_LAND_LOST_RC_LINK);
  }
  static get EMERGENCY_LAND_TEGRA_HEALTH_MONITOR_STALE() {
    return new fault_t(option_t.EMERGENCY_LAND_TEGRA_HEALTH_MONITOR_STALE);
  }
  static get EMERGENCY_LAND_TEGRA_ATTITUDE_COMMAND_STALE() {
    return new fault_t(option_t.EMERGENCY_LAND_TEGRA_ATTITUDE_COMMAND_STALE);
  }
  static get EMERGENCY_LAND_RC_EMERGENCY_LAND_COMMAND() {
    return new fault_t(option_t.EMERGENCY_LAND_RC_EMERGENCY_LAND_COMMAND);
  }
  static get EMERGENCY_LAND_SYMPC_CONTROLLER_FAILED() {
    return new fault_t(option_t.EMERGENCY_LAND_SYMPC_CONTROLLER_FAILED);
  }
  static get EMERGENCY_LAND_NO_STATE_ESTIMATE_AVAILABLE() {
    return new fault_t(option_t.EMERGENCY_LAND_NO_STATE_ESTIMATE_AVAILABLE);
  }
  static get JOYSTICKS_INPUT_PRE_TAKEOFF() {
    return new fault_t(option_t.JOYSTICKS_INPUT_PRE_TAKEOFF);
  }
  static get TRIGGER_OR_ROLLER_INPUT_PRE_TAKEOFF() {
    return new fault_t(option_t.TRIGGER_OR_ROLLER_INPUT_PRE_TAKEOFF);
  }
  static get JOYSTICKS_INPUT_ERRATIC() {
    return new fault_t(option_t.JOYSTICKS_INPUT_ERRATIC);
  }
  static get MAGNETOMETER_NEEDS_CALIBRATION() {
    return new fault_t(option_t.MAGNETOMETER_NEEDS_CALIBRATION);
  }
  static get MAGNETOMETER_NEEDS_GPS() {
    return new fault_t(option_t.MAGNETOMETER_NEEDS_GPS);
  }
  static get ATTI_RTX_REQUIRES_MAG_CAL() {
    return new fault_t(option_t.ATTI_RTX_REQUIRES_MAG_CAL);
  }
  static get ATTI_RTX_MAG_REQUIRES_LOCATION() {
    return new fault_t(option_t.ATTI_RTX_MAG_REQUIRES_LOCATION);
  }
  static get USER_CAMERA_PHOTO_CAPTURE() {
    return new fault_t(option_t.USER_CAMERA_PHOTO_CAPTURE);
  }
  static get COMMANDED_PAST_POOR_GPS_HEIGHT() {
    return new fault_t(option_t.COMMANDED_PAST_POOR_GPS_HEIGHT);
  }
  static get COMMANDED_PAST_MAX_HEIGHT() {
    return new fault_t(option_t.COMMANDED_PAST_MAX_HEIGHT);
  }
  static get COMMANDED_PAST_INDOOR_POOR_GPS_HEIGHT() {
    return new fault_t(option_t.COMMANDED_PAST_INDOOR_POOR_GPS_HEIGHT);
  }
  static get COMMANDED_PAST_DENSITY_ALTITUDE() {
    return new fault_t(option_t.COMMANDED_PAST_DENSITY_ALTITUDE);
  }
  static get COMMANDED_PAST_POOR_GPS_HEIGHT_NOT_DISMISSED() {
    return new fault_t(option_t.COMMANDED_PAST_POOR_GPS_HEIGHT_NOT_DISMISSED);
  }
  static get COMMANDED_PAST_MAX_HEIGHT_NOT_DISMISSED() {
    return new fault_t(option_t.COMMANDED_PAST_MAX_HEIGHT_NOT_DISMISSED);
  }
  static get COMMANDED_PAST_INDOOR_POOR_GPS_HEIGHT_NOT_DISMISSED() {
    return new fault_t(option_t.COMMANDED_PAST_INDOOR_POOR_GPS_HEIGHT_NOT_DISMISSED);
  }
  static get AT_GEOFENCE_EDGE() {
    return new fault_t(option_t.AT_GEOFENCE_EDGE);
  }
  static get AT_GEOFENCE_EDGE_NOT_DISMISSED() {
    return new fault_t(option_t.AT_GEOFENCE_EDGE_NOT_DISMISSED);
  }
  static get RETURNING_TO_GEOFENCE() {
    return new fault_t(option_t.RETURNING_TO_GEOFENCE);
  }
  static get RETURNING_TO_GEOFENCE_NOT_DISMISSED() {
    return new fault_t(option_t.RETURNING_TO_GEOFENCE_NOT_DISMISSED);
  }
  static get FAR_OUTSIDE_GEOFENCE() {
    return new fault_t(option_t.FAR_OUTSIDE_GEOFENCE);
  }
  static get GEOFENCE_UNRELIABLE() {
    return new fault_t(option_t.GEOFENCE_UNRELIABLE);
  }
  static get GEOFENCE_GPS_REQUIRED() {
    return new fault_t(option_t.GEOFENCE_GPS_REQUIRED);
  }
  static get GEOFENCE_AGL_HEIGHTS_REQUIRED() {
    return new fault_t(option_t.GEOFENCE_AGL_HEIGHTS_REQUIRED);
  }
  static get VEHICLE_NEEDS_ASSISTNOW() {
    return new fault_t(option_t.VEHICLE_NEEDS_ASSISTNOW);
  }
  static get SKILLS_LATENCY_HIGH() {
    return new fault_t(option_t.SKILLS_LATENCY_HIGH);
  }
  static get DOCK_NOT_READY_FOR_TAKEOFF() {
    return new fault_t(option_t.DOCK_NOT_READY_FOR_TAKEOFF);
  }
  static get WEBRTC_OFFLINE() {
    return new fault_t(option_t.WEBRTC_OFFLINE);
  }
  static get DOCK_DISCONNECTED() {
    return new fault_t(option_t.DOCK_DISCONNECTED);
  }
  static get DOCK_DETECTED() {
    return new fault_t(option_t.DOCK_DETECTED);
  }
  static get VEHICLE_ON_SOME_TAKEOFF_SURFACE() {
    return new fault_t(option_t.VEHICLE_ON_SOME_TAKEOFF_SURFACE);
  }
  static get DOCK_IN_INSPECTION_MODE() {
    return new fault_t(option_t.DOCK_IN_INSPECTION_MODE);
  }
  static get DIGITAL_ZOOM_UNAVAILABLE() {
    return new fault_t(option_t.DIGITAL_ZOOM_UNAVAILABLE);
  }
  static get SUPERZOOM_UNAVAILABLE_SUBJECT_TRACKING() {
    return new fault_t(option_t.SUPERZOOM_UNAVAILABLE_SUBJECT_TRACKING);
  }
  static get MOTOR_CURRENT_WARNING() {
    return new fault_t(option_t.MOTOR_CURRENT_WARNING);
  }
  static get MOTOR_CURRENT_CRITICAL() {
    return new fault_t(option_t.MOTOR_CURRENT_CRITICAL);
  }
  static get MOTOR_IDLE_OVERCURRENT_CRITICAL() {
    return new fault_t(option_t.MOTOR_IDLE_OVERCURRENT_CRITICAL);
  }
  static get MOTOR_IDLE_OVERCURRENT_WARNING() {
    return new fault_t(option_t.MOTOR_IDLE_OVERCURRENT_WARNING);
  }
  static get AIRHAWK_ATTITUDE_CONTROL_REQ_RESTART() {
    return new fault_t(option_t.AIRHAWK_ATTITUDE_CONTROL_REQ_RESTART);
  }
  static get DEFAULT_WIFI_AP_CREDENTIALS() {
    return new fault_t(option_t.DEFAULT_WIFI_AP_CREDENTIALS);
  }
  static get IMPERFECT_CONTACT_WITH_DOCK() {
    return new fault_t(option_t.IMPERFECT_CONTACT_WITH_DOCK);
  }
  static get LOST_CONNECTION_DROP_VIDEO() {
    return new fault_t(option_t.LOST_CONNECTION_DROP_VIDEO);
  }
  static get ARM_IMPROPER_POSITION_VISION() {
    return new fault_t(option_t.ARM_IMPROPER_POSITION_VISION);
  }
  static get ARM_IMPROPER_POSITION_CRITICAL() {
    return new fault_t(option_t.ARM_IMPROPER_POSITION_CRITICAL);
  }
  static get ARM_IMPROPER_POSITION_VISION_BLOCK_TAKEOFF() {
    return new fault_t(option_t.ARM_IMPROPER_POSITION_VISION_BLOCK_TAKEOFF);
  }
  static get VIO_CALIBRATIONS_NOT_CONVERGED() {
    return new fault_t(option_t.VIO_CALIBRATIONS_NOT_CONVERGED);
  }
  static get AUTO_GPS_INITIALIZATION_FAILED() {
    return new fault_t(option_t.AUTO_GPS_INITIALIZATION_FAILED);
  }
  static get BEACON_BARO_OFFSET_NEEDED() {
    return new fault_t(option_t.BEACON_BARO_OFFSET_NEEDED);
  }
  static get DOCK_VEHICLE_PAIRING_MISMATCH() {
    return new fault_t(option_t.DOCK_VEHICLE_PAIRING_MISMATCH);
  }
  static get RID_KEY_REQUIRED() {
    return new fault_t(option_t.RID_KEY_REQUIRED);
  }
  static get MOTOR_VIBE_CHECK_PENDING() {
    return new fault_t(option_t.MOTOR_VIBE_CHECK_PENDING);
  }
  static get EXCESSIVE_MOTOR_VIBE() {
    return new fault_t(option_t.EXCESSIVE_MOTOR_VIBE);
  }
  static get MANUAL_MODE_RECOMMENDED() {
    return new fault_t(option_t.MANUAL_MODE_RECOMMENDED);
  }
  static get RID_CHECK_STARTED() {
    return new fault_t(option_t.RID_CHECK_STARTED);
  }
  static get WIFI_NO_CONFIGURED_SSIDS_FOUND() {
    return new fault_t(option_t.WIFI_NO_CONFIGURED_SSIDS_FOUND);
  }
  static get WIFI_AUTHENTICATION_ERROR() {
    return new fault_t(option_t.WIFI_AUTHENTICATION_ERROR);
  }
  static get WIFI_CONNECTION_TIMEOUT() {
    return new fault_t(option_t.WIFI_CONNECTION_TIMEOUT);
  }
  static get WIFI_CHIP_CRASHED() {
    return new fault_t(option_t.WIFI_CHIP_CRASHED);
  }
  static get CONTROLLER_GPS_QUALITY_INSUFFICIENT() {
    return new fault_t(option_t.CONTROLLER_GPS_QUALITY_INSUFFICIENT);
  }
  static get RID_CONTROLLER_GPS_INOPERATIVE() {
    return new fault_t(option_t.RID_CONTROLLER_GPS_INOPERATIVE);
  }
  static get RID_RPIC_GPS_INOPERATIVE() {
    return new fault_t(option_t.RID_RPIC_GPS_INOPERATIVE);
  }
  static get DOCK_CRADLE_EXTENDED_PRE_TAKEOFF() {
    return new fault_t(option_t.DOCK_CRADLE_EXTENDED_PRE_TAKEOFF);
  }
  static get IS_BASESTATION_TAKEOFF_SURFACE() {
    return new fault_t(option_t.IS_BASESTATION_TAKEOFF_SURFACE);
  }
  static get IS_BASESTATION_LANDING_SURFACE() {
    return new fault_t(option_t.IS_BASESTATION_LANDING_SURFACE);
  }
  static get LANDED_OUTSIDE_DOCK() {
    return new fault_t(option_t.LANDED_OUTSIDE_DOCK);
  }
  static get AIRHAWK_RT_LOSS() {
    return new fault_t(option_t.AIRHAWK_RT_LOSS);
  }
  static get AIRHAWK_TIMING_FAULT() {
    return new fault_t(option_t.AIRHAWK_TIMING_FAULT);
  }
  static get LIVEKIT_NO_CONFIG() {
    return new fault_t(option_t.LIVEKIT_NO_CONFIG);
  }
  static get LIVEKIT_CONFIG_MISMATCH() {
    return new fault_t(option_t.LIVEKIT_CONFIG_MISMATCH);
  }
  static get LIVEKIT_NOT_ENABLED() {
    return new fault_t(option_t.LIVEKIT_NOT_ENABLED);
  }
  static get LIVEKIT_CONNECTED() {
    return new fault_t(option_t.LIVEKIT_CONNECTED);
  }
  static get LIVEKIT_CONNECTION_FAILED() {
    return new fault_t(option_t.LIVEKIT_CONNECTION_FAILED);
  }
  static get VEHICLE_GPS_QUALITY_BLOCKING_TWILIGHT() {
    return new fault_t(option_t.VEHICLE_GPS_QUALITY_BLOCKING_TWILIGHT);
  }
  static get FLIGHT_TERMINATED() {
    return new fault_t(option_t.FLIGHT_TERMINATED);
  }
  static get NAV_CAMERA_LOGGING_DEGRADED() {
    return new fault_t(option_t.NAV_CAMERA_LOGGING_DEGRADED);
  }
  static get SKILLS_TASKS_PENDING() {
    return new fault_t(option_t.SKILLS_TASKS_PENDING);
  }
  static get DOCK_COMMS_UNRELIABLE() {
    return new fault_t(option_t.DOCK_COMMS_UNRELIABLE);
  }
  static get CLOUD_ENV_OUT_OF_SYNC() {
    return new fault_t(option_t.CLOUD_ENV_OUT_OF_SYNC);
  }
  static get TRACK_TRAJECTORY_STUCK_ON_OBSTACLES() {
    return new fault_t(option_t.TRACK_TRAJECTORY_STUCK_ON_OBSTACLES);
  }
  static get SKILLS_TASK_NEEDS_DECRYPTION() {
    return new fault_t(option_t.SKILLS_TASK_NEEDS_DECRYPTION);
  }
  static get USER_CAMERA_SLOW_MODE_SWITCH() {
    return new fault_t(option_t.USER_CAMERA_SLOW_MODE_SWITCH);
  }
  static get NVU_DISCONNECTED() {
    return new fault_t(option_t.NVU_DISCONNECTED);
  }
  static get QCU_DISCONNECTED() {
    return new fault_t(option_t.QCU_DISCONNECTED);
  }
  static get BARO_MEASUREMENT_UNRELIABLE() {
    return new fault_t(option_t.BARO_MEASUREMENT_UNRELIABLE);
  }
  static get WAYPOINTS_UNRELIABLE() {
    return new fault_t(option_t.WAYPOINTS_UNRELIABLE);
  }
  static get A_STAR_FRONT_UNRELIABLE() {
    return new fault_t(option_t.A_STAR_FRONT_UNRELIABLE);
  }
  static get WAYPOINT_TASK_STUCK_ON_OBSTACLE() {
    return new fault_t(option_t.WAYPOINT_TASK_STUCK_ON_OBSTACLE);
  }
  static get WAYPOINT_TASK_STUCK_ON_GEOFENCE() {
    return new fault_t(option_t.WAYPOINT_TASK_STUCK_ON_GEOFENCE);
  }
  static get WAYPOINT_TASK_STUCK_ON_NEARBY_DRONE() {
    return new fault_t(option_t.WAYPOINT_TASK_STUCK_ON_NEARBY_DRONE);
  }
  static get DOCK_CLIENT_UNRELIABLE() {
    return new fault_t(option_t.DOCK_CLIENT_UNRELIABLE);
  }
  static get SPURIOUS_VOXELS_DAY() {
    return new fault_t(option_t.SPURIOUS_VOXELS_DAY);
  }
  static get SPURIOUS_VOXELS_NIGHT() {
    return new fault_t(option_t.SPURIOUS_VOXELS_NIGHT);
  }
  static get SPURIOUS_VOXELS_DEBUG() {
    return new fault_t(option_t.SPURIOUS_VOXELS_DEBUG);
  }
  static get BAD_GPU_FREQUENCY_QCU() {
    return new fault_t(option_t.BAD_GPU_FREQUENCY_QCU);
  }
  static get CPU_TOO_HIGH_QCU() {
    return new fault_t(option_t.CPU_TOO_HIGH_QCU);
  }
  static get GPU_TOO_HIGH_QCU() {
    return new fault_t(option_t.GPU_TOO_HIGH_QCU);
  }
  static get BASE_PROCESSES_STOPPED_QCU() {
    return new fault_t(option_t.BASE_PROCESSES_STOPPED_QCU);
  }
  static get FLIGHT_PROCESSES_STOPPED_QCU() {
    return new fault_t(option_t.FLIGHT_PROCESSES_STOPPED_QCU);
  }
  static get MEMORY_LOW_QCU() {
    return new fault_t(option_t.MEMORY_LOW_QCU);
  }
  static get TOO_MANY_PAGE_FAULTS_QCU() {
    return new fault_t(option_t.TOO_MANY_PAGE_FAULTS_QCU);
  }
  static get FLIGHT_DECK_OUT_OF_SYNC_QCU() {
    return new fault_t(option_t.FLIGHT_DECK_OUT_OF_SYNC_QCU);
  }
  static get TOF_UNRELIABLE() {
    return new fault_t(option_t.TOF_UNRELIABLE);
  }
  static get TOF_UNRELIABLE_FOR_FAST_DESCENT_LANDING() {
    return new fault_t(option_t.TOF_UNRELIABLE_FOR_FAST_DESCENT_LANDING);
  }
  static get INFRARED_CAMERA_UNRELIABLE() {
    return new fault_t(option_t.INFRARED_CAMERA_UNRELIABLE);
  }
  static get TOO_FAST_NIGHT_AUTONOMY() {
    return new fault_t(option_t.TOO_FAST_NIGHT_AUTONOMY);
  }
  static get VEHICLE_RADIO_UPDATE_IN_PROGRESS() {
    return new fault_t(option_t.VEHICLE_RADIO_UPDATE_IN_PROGRESS);
  }
  static get ATTACHMENT_CHANGE_DETECTED() {
    return new fault_t(option_t.ATTACHMENT_CHANGE_DETECTED);
  }
  static get MISMATCHED_NIGHTSENSE_ATTACHMENT_DETECTED() {
    return new fault_t(option_t.MISMATCHED_NIGHTSENSE_ATTACHMENT_DETECTED);
  }
  static get MIXED_NIGHTSENSE_ATTACHMENTS_DETECTED() {
    return new fault_t(option_t.MIXED_NIGHTSENSE_ATTACHMENTS_DETECTED);
  }
  static get RTK_PPK_ATTACHMENT_CONNECTED() {
    return new fault_t(option_t.RTK_PPK_ATTACHMENT_CONNECTED);
  }
  static get RTK_PPK_ATTACHMENT_CONNECTED_NOT_DISMISSED() {
    return new fault_t(option_t.RTK_PPK_ATTACHMENT_CONNECTED_NOT_DISMISSED);
  }
  static get NIGHTSENSE_ATTACHMENT_DEGRADED() {
    return new fault_t(option_t.NIGHTSENSE_ATTACHMENT_DEGRADED);
  }
  static get NIGHTSENSE_ATTACHMENT_DEGRADED_NOT_DISMISSED() {
    return new fault_t(option_t.NIGHTSENSE_ATTACHMENT_DEGRADED_NOT_DISMISSED);
  }
  static get NIGHTSENSE_DISABLED_ATTACHMENT_FAILURE() {
    return new fault_t(option_t.NIGHTSENSE_DISABLED_ATTACHMENT_FAILURE);
  }
  static get NIGHTSENSE_DISABLED_ATTACHMENT_FAILURE_NOT_DISMISSED() {
    return new fault_t(option_t.NIGHTSENSE_DISABLED_ATTACHMENT_FAILURE_NOT_DISMISSED);
  }
  static get NIGHTSENSE_DISABLED_ATTACHMENT_DISCONNECTED() {
    return new fault_t(option_t.NIGHTSENSE_DISABLED_ATTACHMENT_DISCONNECTED);
  }
  static get NIGHTSENSE_DISABLED_ATTACHMENT_DISCONNECTED_NOT_DISMISSED() {
    return new fault_t(option_t.NIGHTSENSE_DISABLED_ATTACHMENT_DISCONNECTED_NOT_DISMISSED);
  }
  static get NIGHTSENSE_UNAVAILABLE_ATTACHMENT_MISSING() {
    return new fault_t(option_t.NIGHTSENSE_UNAVAILABLE_ATTACHMENT_MISSING);
  }
  static get NIGHTSENSE_UNAVAILABLE_ATTACHMENT_MISSING_NOT_DISMISSED() {
    return new fault_t(option_t.NIGHTSENSE_UNAVAILABLE_ATTACHMENT_MISSING_NOT_DISMISSED);
  }
  static get PARACHUTE_FIRMWARE_VERSION_MISMATCH() {
    return new fault_t(option_t.PARACHUTE_FIRMWARE_VERSION_MISMATCH);
  }
  static get PARACHUTE_DEGRADED() {
    return new fault_t(option_t.PARACHUTE_DEGRADED);
  }
  static get PARACHUTE_DEGRADED_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_DEGRADED_NOT_DISMISSED);
  }
  static get PARACHUTE_NON_CRITICAL_FAILURE() {
    return new fault_t(option_t.PARACHUTE_NON_CRITICAL_FAILURE);
  }
  static get PARACHUTE_NON_CRITICAL_FAILURE_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_NON_CRITICAL_FAILURE_NOT_DISMISSED);
  }
  static get PARACHUTE_CRITICAL_FAILURE() {
    return new fault_t(option_t.PARACHUTE_CRITICAL_FAILURE);
  }
  static get PARACHUTE_CRITICAL_FAILURE_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_CRITICAL_FAILURE_NOT_DISMISSED);
  }
  static get PARACHUTE_CRITICAL_ATS_FAILURE() {
    return new fault_t(option_t.PARACHUTE_CRITICAL_ATS_FAILURE);
  }
  static get PARACHUTE_CRITICAL_ATS_FAILURE_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_CRITICAL_ATS_FAILURE_NOT_DISMISSED);
  }
  static get PARACHUTE_COMMS_LOST() {
    return new fault_t(option_t.PARACHUTE_COMMS_LOST);
  }
  static get PARACHUTE_AIRHAWK_HEARTBEAT_STALE() {
    return new fault_t(option_t.PARACHUTE_AIRHAWK_HEARTBEAT_STALE);
  }
  static get PARACHUTE_SELF_CHECK_IN_PROGRESS() {
    return new fault_t(option_t.PARACHUTE_SELF_CHECK_IN_PROGRESS);
  }
  static get PARACHUTE_SELF_CHECK_MARGINAL() {
    return new fault_t(option_t.PARACHUTE_SELF_CHECK_MARGINAL);
  }
  static get PARACHUTE_SELF_CHECK_MARGINAL_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_SELF_CHECK_MARGINAL_NOT_DISMISSED);
  }
  static get PARACHUTE_SELF_CHECK_FAILED() {
    return new fault_t(option_t.PARACHUTE_SELF_CHECK_FAILED);
  }
  static get PARACHUTE_HAS_LOGS() {
    return new fault_t(option_t.PARACHUTE_HAS_LOGS);
  }
  static get PARACHUTE_REQUIRED_BUT_MISSING() {
    return new fault_t(option_t.PARACHUTE_REQUIRED_BUT_MISSING);
  }
  static get PARACHUTE_REQUIRED_BUT_MISSING_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_REQUIRED_BUT_MISSING_NOT_DISMISSED);
  }
  static get PARACHUTE_EXPECTED_BUT_MISSING() {
    return new fault_t(option_t.PARACHUTE_EXPECTED_BUT_MISSING);
  }
  static get PARACHUTE_EXPECTED_BUT_MISSING_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_EXPECTED_BUT_MISSING_NOT_DISMISSED);
  }
  static get PARACHUTE_UNKNOWN_HARDWARE_VERSION() {
    return new fault_t(option_t.PARACHUTE_UNKNOWN_HARDWARE_VERSION);
  }
  static get PARACHUTE_UNKNOWN_HARDWARE_VERSION_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_UNKNOWN_HARDWARE_VERSION_NOT_DISMISSED);
  }
  static get PARACHUTE_EXPIRED() {
    return new fault_t(option_t.PARACHUTE_EXPIRED);
  }
  static get PARACHUTE_EXPIRED_NOT_DISMISSED() {
    return new fault_t(option_t.PARACHUTE_EXPIRED_NOT_DISMISSED);
  }
  static get FLASH_DRIVE_REQUIRED() {
    return new fault_t(option_t.FLASH_DRIVE_REQUIRED);
  }
  static get HOUSEKEEPER_MCU_VERSION_MISMATCH() {
    return new fault_t(option_t.HOUSEKEEPER_MCU_VERSION_MISMATCH);
  }
  static get AIRHAWK_MCU_VERSION_MISMATCH() {
    return new fault_t(option_t.AIRHAWK_MCU_VERSION_MISMATCH);
  }
  static get GIMBAL_MCU_VERSION_MISMATCH() {
    return new fault_t(option_t.GIMBAL_MCU_VERSION_MISMATCH);
  }
  static get SOC_FLASHPACK_MISMATCH() {
    return new fault_t(option_t.SOC_FLASHPACK_MISMATCH);
  }
  static get SOC_CONFIG_MISMATCH() {
    return new fault_t(option_t.SOC_CONFIG_MISMATCH);
  }
  static get SOC_SERIAL_NUMBER_MISMATCH() {
    return new fault_t(option_t.SOC_SERIAL_NUMBER_MISMATCH);
  }
  static get OTA_IN_PROGRESS() {
    return new fault_t(option_t.OTA_IN_PROGRESS);
  }
  static get FIRMWARE_MISCONFIGURED() {
    return new fault_t(option_t.FIRMWARE_MISCONFIGURED);
  }
  static get AIRHAWK_SERIAL_CONNECTION_LOST() {
    return new fault_t(option_t.AIRHAWK_SERIAL_CONNECTION_LOST);
  }
  static get AIRHAWK_SERIAL_CONNECTION_LOST_QCU() {
    return new fault_t(option_t.AIRHAWK_SERIAL_CONNECTION_LOST_QCU);
  }
  static get OBSTACLE_MARGINS_CANNOT_EXPAND() {
    return new fault_t(option_t.OBSTACLE_MARGINS_CANNOT_EXPAND);
  }
  static get MOTOR_TAKEOFF_CURRENT_CRITICAL() {
    return new fault_t(option_t.MOTOR_TAKEOFF_CURRENT_CRITICAL);
  }
  static get RELATIVE_HEADING_ESTIMATE_UNAVAILABLE() {
    return new fault_t(option_t.RELATIVE_HEADING_ESTIMATE_UNAVAILABLE);
  }
  static get IMU_SATURATION_ON_TAKEOFF() {
    return new fault_t(option_t.IMU_SATURATION_ON_TAKEOFF);
  }
  static get VEHICLE_GPS_RESET() {
    return new fault_t(option_t.VEHICLE_GPS_RESET);
  }
  static get PRE_DOCK_TAKEOFF_VEHICLE_GPS_RESET_UNSUCCESSFUL() {
    return new fault_t(option_t.PRE_DOCK_TAKEOFF_VEHICLE_GPS_RESET_UNSUCCESSFUL);
  }
  static get GIMBAL_FLASH_FAILED() {
    return new fault_t(option_t.GIMBAL_FLASH_FAILED);
  }
  static get INFRARED_CAMERA_POOR_ACCURACY() {
    return new fault_t(option_t.INFRARED_CAMERA_POOR_ACCURACY);
  }
  static get GIMBAL_TYPE_INCOMPATIBLE() {
    return new fault_t(option_t.GIMBAL_TYPE_INCOMPATIBLE);
  }
  static get FRONT_UNRELIABLE() {
    return new fault_t(option_t.FRONT_UNRELIABLE);
  }
  static get MOTOR_OSCILLATION_DETECTED() {
    return new fault_t(option_t.MOTOR_OSCILLATION_DETECTED);
  }
  static get ATTACHMENT_OLD_SIDE_ATTACHMENT_HARDWARE() {
    return new fault_t(option_t.ATTACHMENT_OLD_SIDE_ATTACHMENT_HARDWARE);
  }
  static get ATTACHMENT_WRONG_CABLE_ORIENTATION() {
    return new fault_t(option_t.ATTACHMENT_WRONG_CABLE_ORIENTATION);
  }
  static get ATTACHMENT_ENUMERATION_IN_PROGRESS() {
    return new fault_t(option_t.ATTACHMENT_ENUMERATION_IN_PROGRESS);
  }
  static get ATTACHMENT_IN_INVALID_PORT_TOP() {
    return new fault_t(option_t.ATTACHMENT_IN_INVALID_PORT_TOP);
  }
  static get ATTACHMENT_IN_INVALID_PORT_BOTTOM() {
    return new fault_t(option_t.ATTACHMENT_IN_INVALID_PORT_BOTTOM);
  }
  static get ATTACHMENT_IN_INVALID_PORT_LEFT() {
    return new fault_t(option_t.ATTACHMENT_IN_INVALID_PORT_LEFT);
  }
  static get ATTACHMENT_IN_INVALID_PORT_RIGHT() {
    return new fault_t(option_t.ATTACHMENT_IN_INVALID_PORT_RIGHT);
  }
  static get ATTACHMENT_INSPECT_OR_REPLACE_TOP() {
    return new fault_t(option_t.ATTACHMENT_INSPECT_OR_REPLACE_TOP);
  }
  static get ATTACHMENT_INSPECT_OR_REPLACE_BOTTOM() {
    return new fault_t(option_t.ATTACHMENT_INSPECT_OR_REPLACE_BOTTOM);
  }
  static get ATTACHMENT_INSPECT_OR_REPLACE_LEFT() {
    return new fault_t(option_t.ATTACHMENT_INSPECT_OR_REPLACE_LEFT);
  }
  static get ATTACHMENT_INSPECT_OR_REPLACE_RIGHT() {
    return new fault_t(option_t.ATTACHMENT_INSPECT_OR_REPLACE_RIGHT);
  }
  static get ATTACHMENT_NIGHTSENSE_VERSION_MISMATCH() {
    return new fault_t(option_t.ATTACHMENT_NIGHTSENSE_VERSION_MISMATCH);
  }
  static get ATTACHMENT_NIGHTSENSE_UPDATE_FAILED() {
    return new fault_t(option_t.ATTACHMENT_NIGHTSENSE_UPDATE_FAILED);
  }
  static get ATTACHMENT_NIGHTSENSE_UPDATE_FAILED_NOT_DISMISSED() {
    return new fault_t(option_t.ATTACHMENT_NIGHTSENSE_UPDATE_FAILED_NOT_DISMISSED);
  }
  static get ATTACHMENT_SPOTLIGHT_BRIGHTNESS_THROTTLING() {
    return new fault_t(option_t.ATTACHMENT_SPOTLIGHT_BRIGHTNESS_THROTTLING);
  }
  static get ATTACHMENT_SPOTLIGHT_THERMAL_SHUTDOWN() {
    return new fault_t(option_t.ATTACHMENT_SPOTLIGHT_THERMAL_SHUTDOWN);
  }
  static get ATTACHMENT_SPOTLIGHT_ABOVE_TOUCH_TEMP() {
    return new fault_t(option_t.ATTACHMENT_SPOTLIGHT_ABOVE_TOUCH_TEMP);
  }
  static get ATTACHMENT_PARACHUTE_DEPLOYED() {
    return new fault_t(option_t.ATTACHMENT_PARACHUTE_DEPLOYED);
  }
  static get ATTACHMENT_DROPPER_FIRMWARE_VERSION_MISMATCH() {
    return new fault_t(option_t.ATTACHMENT_DROPPER_FIRMWARE_VERSION_MISMATCH);
  }
  static get ATTACHMENT_DROPPER_FIRMWARE_UPDATE_FAILED() {
    return new fault_t(option_t.ATTACHMENT_DROPPER_FIRMWARE_UPDATE_FAILED);
  }
  static get ATTACHMENT_DROPPER_FIRMWARE_UPDATE_FAILED_NOT_DISMISSED() {
    return new fault_t(option_t.ATTACHMENT_DROPPER_FIRMWARE_UPDATE_FAILED_NOT_DISMISSED);
  }
  static get ATTACHMENT_DROPPER_CRITICAL_FAILURE() {
    return new fault_t(option_t.ATTACHMENT_DROPPER_CRITICAL_FAILURE);
  }
  static get ATTACHMENT_DROPPER_CRITICAL_FAILURE_NOT_DISMISSED() {
    return new fault_t(option_t.ATTACHMENT_DROPPER_CRITICAL_FAILURE_NOT_DISMISSED);
  }
  static get ATTACHMENT_RTK_COM_FAILURE() {
    return new fault_t(option_t.ATTACHMENT_RTK_COM_FAILURE);
  }
  static get ATTACHMENT_SPEAKERMIC_LOW_VOLUME() {
    return new fault_t(option_t.ATTACHMENT_SPEAKERMIC_LOW_VOLUME);
  }
  static get ATTACHMENT_CELLULAR_MODEM_UNRESPONSIVE() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_UNRESPONSIVE);
  }
  static get ATTACHMENT_CELLULAR_MODEM_IN_BOOTLOADER() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_IN_BOOTLOADER);
  }
  static get ATTACHMENT_CELLULAR_MODEM_ENABLED_BUT_DISCONNECTED() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_ENABLED_BUT_DISCONNECTED);
  }
  static get ATTACHMENT_CELLULAR_MODEM_DISABLED_BUT_CONNECTED() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_DISABLED_BUT_CONNECTED);
  }
  static get ATTACHMENT_CELLULAR_MODEM_CORRUPTED() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_CORRUPTED);
  }
  static get ATTACHMENT_CELLULAR_MODEM_NO_SIM_CONFIG() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_NO_SIM_CONFIG);
  }
  static get ATTACHMENT_CELLULAR_MODEM_NO_SIM_CONFIG_NOT_DISMISSED() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_NO_SIM_CONFIG_NOT_DISMISSED);
  }
  static get ATTACHMENT_CELLULAR_MODEM_NO_RX() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_NO_RX);
  }
  static get ATTACHMENT_CELLULAR_MODEM_NO_SIM_INSERTED() {
    return new fault_t(option_t.ATTACHMENT_CELLULAR_MODEM_NO_SIM_INSERTED);
  }
  static get ATTACHMENT_SPOTLIGHT_TWO_SPOTLIGHTS_UNSUPPORTED() {
    return new fault_t(option_t.ATTACHMENT_SPOTLIGHT_TWO_SPOTLIGHTS_UNSUPPORTED);
  }
  static get ATTACHMENT_INVALID_COMBINATION() {
    return new fault_t(option_t.ATTACHMENT_INVALID_COMBINATION);
  }
  static get RID_TX_FAILURE() {
    return new fault_t(option_t.RID_TX_FAILURE);
  }
  static get PINE_HIGH_INTERFERENCE() {
    return new fault_t(option_t.PINE_HIGH_INTERFERENCE);
  }
  static get PINE_SU_PKTS_IN_OFDMA() {
    return new fault_t(option_t.PINE_SU_PKTS_IN_OFDMA);
  }
  static get PINE_CLOSE_INTERFERENCE() {
    return new fault_t(option_t.PINE_CLOSE_INTERFERENCE);
  }
  static get PINE_PERSISTENT_HIGH_INTERFERENCE() {
    return new fault_t(option_t.PINE_PERSISTENT_HIGH_INTERFERENCE);
  }
  static get PINE_RADAR_DETECTED() {
    return new fault_t(option_t.PINE_RADAR_DETECTED);
  }
  static get PINE_RADAR_DETECTED_NOT_DISMISSED() {
    return new fault_t(option_t.PINE_RADAR_DETECTED_NOT_DISMISSED);
  }
  static get NCPG_SAVE_IN_PROGRESS() {
    return new fault_t(option_t.NCPG_SAVE_IN_PROGRESS);
  }
  static get MISSION_CONDUCTOR_DISABLE_PILOTSHIP() {
    return new fault_t(option_t.MISSION_CONDUCTOR_DISABLE_PILOTSHIP);
  }
  static get GROUND_AVOIDANCE_ACTIVE() {
    return new fault_t(option_t.GROUND_AVOIDANCE_ACTIVE);
  }
  static get GPS_SPOOFED() {
    return new fault_t(option_t.GPS_SPOOFED);
  }
  static get GPS_INVALID_TIME() {
    return new fault_t(option_t.GPS_INVALID_TIME);
  }
  static get EVENT_LOOP_FD_OVERFLOW() {
    return new fault_t(option_t.EVENT_LOOP_FD_OVERFLOW);
  }
  static get MICROHARD_DCS_JAMMING_FAULT() {
    return new fault_t(option_t.MICROHARD_DCS_JAMMING_FAULT);
  }
  static get BATTERY_NOT_ARMED() {
    return new fault_t(option_t.BATTERY_NOT_ARMED);
  }
  static get VEHICLE_TOO_HOT_CRITICAL_FINAL() {
    return new fault_t(option_t.VEHICLE_TOO_HOT_CRITICAL_FINAL);
  }
  static get IMU_NEAR_SATURATION() {
    return new fault_t(option_t.IMU_NEAR_SATURATION);
  }
  static get ATTI_TAKEOFF_AWAITING_USER_INPUT() {
    return new fault_t(option_t.ATTI_TAKEOFF_AWAITING_USER_INPUT);
  }
  static get VEHICLE_CLOCK_STALE() {
    return new fault_t(option_t.VEHICLE_CLOCK_STALE);
  }
  static get VEHICLE_CLOCK_STALE_NOT_DISMISSED() {
    return new fault_t(option_t.VEHICLE_CLOCK_STALE_NOT_DISMISSED);
  }
  static get FLIR_FIRMWARE_UPDATE_IN_PROGRESS() {
    return new fault_t(option_t.FLIR_FIRMWARE_UPDATE_IN_PROGRESS);
  }
  static get FLIR_FIRMWARE_VERSION_MISMATCH() {
    return new fault_t(option_t.FLIR_FIRMWARE_VERSION_MISMATCH);
  }
  static get NAV_FRAME_UNRELIABLE() {
    return new fault_t(option_t.NAV_FRAME_UNRELIABLE);
  }
  static get MISSION_NOT_READY_FOR_TAKEOFF() {
    return new fault_t(option_t.MISSION_NOT_READY_FOR_TAKEOFF);
  }
  static get UNEXPECTED_OBSTACLES_HIGH_SPEED() {
    return new fault_t(option_t.UNEXPECTED_OBSTACLES_HIGH_SPEED);
  }
  static get APPROACHING_GEOAWARENESS_ZONE() {
    return new fault_t(option_t.APPROACHING_GEOAWARENESS_ZONE);
  }
  static get ENTERED_GEOAWARENESS_ZONE() {
    return new fault_t(option_t.ENTERED_GEOAWARENESS_ZONE);
  }
  static get GEOAWARENESS_UNAVAILABLE_FILE() {
    return new fault_t(option_t.GEOAWARENESS_UNAVAILABLE_FILE);
  }
  static get GEOAWARENESS_UNAVAILABLE_GPS() {
    return new fault_t(option_t.GEOAWARENESS_UNAVAILABLE_GPS);
  }
  static get YIELD_FOR_NEARBY_DRONES() {
    return new fault_t(option_t.YIELD_FOR_NEARBY_DRONES);
  }
  static get YIELD_FOR_NEARBY_DRONES_NOT_DISMISSED() {
    return new fault_t(option_t.YIELD_FOR_NEARBY_DRONES_NOT_DISMISSED);
  }
  static get AWAITING_CLOUD_CONFIG_UPDATE() {
    return new fault_t(option_t.AWAITING_CLOUD_CONFIG_UPDATE);
  }
  static get UPDATED_CLOUD_CONFIG_REBOOT_REQUIRED() {
    return new fault_t(option_t.UPDATED_CLOUD_CONFIG_REBOOT_REQUIRED);
  }
  static get SETUP_FLIGHT_INCOMPLETE() {
    return new fault_t(option_t.SETUP_FLIGHT_INCOMPLETE);
  }
  static get SETUP_FLIGHT_INCOMPLETE_CLOUD() {
    return new fault_t(option_t.SETUP_FLIGHT_INCOMPLETE_CLOUD);
  }
  static get SETUP_FLIGHT_IN_PROGRESS() {
    return new fault_t(option_t.SETUP_FLIGHT_IN_PROGRESS);
  }
  static get AWAITING_SETUP_FLIGHT_RESULTS() {
    return new fault_t(option_t.AWAITING_SETUP_FLIGHT_RESULTS);
  }
  static get SETUP_FLIGHT_FAILED() {
    return new fault_t(option_t.SETUP_FLIGHT_FAILED);
  }
  static get SETUP_FLIGHT_FAILED_TAG_SET_VERIFICATION() {
    return new fault_t(option_t.SETUP_FLIGHT_FAILED_TAG_SET_VERIFICATION);
  }
  static get SETUP_FLIGHT_FAILED_GPS() {
    return new fault_t(option_t.SETUP_FLIGHT_FAILED_GPS);
  }
  static get SETUP_FLIGHT_FAILED_GOTO_WAYPOINT() {
    return new fault_t(option_t.SETUP_FLIGHT_FAILED_GOTO_WAYPOINT);
  }
  static get DRONE_FAR_FROM_DOCK() {
    return new fault_t(option_t.DRONE_FAR_FROM_DOCK);
  }
  static get DOCK_HEADING_MISMATCH() {
    return new fault_t(option_t.DOCK_HEADING_MISMATCH);
  }
  static get INACCURATE_DOCK_LANDING() {
    return new fault_t(option_t.INACCURATE_DOCK_LANDING);
  }
  static get CELLULAR_MODEM_UNRESPONSIVE() {
    return new fault_t(option_t.CELLULAR_MODEM_UNRESPONSIVE);
  }
  static get CELLULAR_MODEM_IN_BOOTLOADER() {
    return new fault_t(option_t.CELLULAR_MODEM_IN_BOOTLOADER);
  }
  static get CELLULAR_MODEM_ENABLED_BUT_DISCONNECTED() {
    return new fault_t(option_t.CELLULAR_MODEM_ENABLED_BUT_DISCONNECTED);
  }
  static get CELLULAR_MODEM_DISABLED_BUT_CONNECTED() {
    return new fault_t(option_t.CELLULAR_MODEM_DISABLED_BUT_CONNECTED);
  }
  static get CELLULAR_MODEM_AWAITING_ENUMERATION() {
    return new fault_t(option_t.CELLULAR_MODEM_AWAITING_ENUMERATION);
  }
  static get CELLULAR_MODEM_CORRUPTED() {
    return new fault_t(option_t.CELLULAR_MODEM_CORRUPTED);
  }
  static get CELLULAR_MODEM_NO_SIM_CONFIG() {
    return new fault_t(option_t.CELLULAR_MODEM_NO_SIM_CONFIG);
  }
  static get CELLULAR_MODEM_NO_SIM_CONFIG_NOT_DISMISSED() {
    return new fault_t(option_t.CELLULAR_MODEM_NO_SIM_CONFIG_NOT_DISMISSED);
  }
  static get CELLULAR_MODEM_NO_RX() {
    return new fault_t(option_t.CELLULAR_MODEM_NO_RX);
  }
  static get CELLULAR_MODEM_NO_SIM_INSERTED() {
    return new fault_t(option_t.CELLULAR_MODEM_NO_SIM_INSERTED);
  }
  static get ESC_TELEMETRY_MISSING() {
    return new fault_t(option_t.ESC_TELEMETRY_MISSING);
  }
  static get ROI_STREAM_STOPPED() {
    return new fault_t(option_t.ROI_STREAM_STOPPED);
  }
  static get SOFTWARE_UPDATE_SUCCEEDED_REBOOT() {
    return new fault_t(option_t.SOFTWARE_UPDATE_SUCCEEDED_REBOOT);
  }
  static get SOFTWARE_UPDATE_FAILED_REBOOT() {
    return new fault_t(option_t.SOFTWARE_UPDATE_FAILED_REBOOT);
  }
  static get FLIGHT_DECK_DATABASE_MALFORMED() {
    return new fault_t(option_t.FLIGHT_DECK_DATABASE_MALFORMED);
  }
  static get WIFI_DFS_CAC_IN_PROGRESS() {
    return new fault_t(option_t.WIFI_DFS_CAC_IN_PROGRESS);
  }
  static get NCR_UNRELIABLE() {
    return new fault_t(option_t.NCR_UNRELIABLE);
  }
  static get NCR_FULL_MAPPING_UNRELIABLE() {
    return new fault_t(option_t.NCR_FULL_MAPPING_UNRELIABLE);
  }
  static get NCR_ONLINE_UNRELIABLE() {
    return new fault_t(option_t.NCR_ONLINE_UNRELIABLE);
  }
  static get MOTOR_ICE_DETECTED() {
    return new fault_t(option_t.MOTOR_ICE_DETECTED);
  }
  static get COLD_WEATHER_ICING_RISK() {
    return new fault_t(option_t.COLD_WEATHER_ICING_RISK);
  }
  static get FLIR_USB_NOT_CONNECTED() {
    return new fault_t(option_t.FLIR_USB_NOT_CONNECTED);
  }
  static get RETURN_TO_DOCK_UNAVAILABLE() {
    return new fault_t(option_t.RETURN_TO_DOCK_UNAVAILABLE);
  }
  static get CUSTOMER_NFS_MOUNT_FAILED() {
    return new fault_t(option_t.CUSTOMER_NFS_MOUNT_FAILED);
  }
  static get PATHFINDER_FAILED_TO_COMPUTE_PATH() {
    return new fault_t(option_t.PATHFINDER_FAILED_TO_COMPUTE_PATH);
  }
  static get PATHFINDER_FAILED_TERRAIN_QUERY() {
    return new fault_t(option_t.PATHFINDER_FAILED_TERRAIN_QUERY);
  }
  static get PATHFINDER_FAILED_GPS_LINEARIZATION() {
    return new fault_t(option_t.PATHFINDER_FAILED_GPS_LINEARIZATION);
  }
  static get PATHFINDER_FAILED_OBSTACLE_AVOIDANCE_DISABLED() {
    return new fault_t(option_t.PATHFINDER_FAILED_OBSTACLE_AVOIDANCE_DISABLED);
  }
  static get PATHFINDER_FAILED_GROUND_TAKEOFF() {
    return new fault_t(option_t.PATHFINDER_FAILED_GROUND_TAKEOFF);
  }
  static get PATHFINDER_FAILED_GPS_QUALITY_INSUFFICIENT() {
    return new fault_t(option_t.PATHFINDER_FAILED_GPS_QUALITY_INSUFFICIENT);
  }
  static get PATHFINDER_FAILED_ALTITUDES_INCONSISTENT() {
    return new fault_t(option_t.PATHFINDER_FAILED_ALTITUDES_INCONSISTENT);
  }
  static get PATHFINDER_FAILED_ESTIMATION_TASK() {
    return new fault_t(option_t.PATHFINDER_FAILED_ESTIMATION_TASK);
  }
  static get PATHFINDER_UNAVAILABLE_MISSING_SITE_DATA() {
    return new fault_t(option_t.PATHFINDER_UNAVAILABLE_MISSING_SITE_DATA);
  }
  static get PATHFINDER_UNAVAILABLE_MISSING_EXTERNAL_DATA() {
    return new fault_t(option_t.PATHFINDER_UNAVAILABLE_MISSING_EXTERNAL_DATA);
  }
  static get PATHFINDER_UNAVAILABLE_OBSTACLE_AVOIDANCE_DISABLED() {
    return new fault_t(option_t.PATHFINDER_UNAVAILABLE_OBSTACLE_AVOIDANCE_DISABLED);
  }
  static get PATHFINDER_UNAVAILABLE_GROUND_TAKEOFF() {
    return new fault_t(option_t.PATHFINDER_UNAVAILABLE_GROUND_TAKEOFF);
  }
  static get PATHFINDER_UNAVAILABLE_FRONT_UNRELIABLE() {
    return new fault_t(option_t.PATHFINDER_UNAVAILABLE_FRONT_UNRELIABLE);
  }
  static get PATHFINDER_UNAVAILABLE_ALTITUDES_INCONSISTENT() {
    return new fault_t(option_t.PATHFINDER_UNAVAILABLE_ALTITUDES_INCONSISTENT);
  }
  static get PATHFINDER_UNAVAILABLE_UNSUPPORTED_VERSION() {
    return new fault_t(option_t.PATHFINDER_UNAVAILABLE_UNSUPPORTED_VERSION);
  }
  static get PATHFINDER_DEGRADED_OUTSIDE_RANGE() {
    return new fault_t(option_t.PATHFINDER_DEGRADED_OUTSIDE_RANGE);
  }
  static get DOCK_CLIENT_UNINITIALIZED() {
    return new fault_t(option_t.DOCK_CLIENT_UNINITIALIZED);
  }
  static get DOCK_HEIGHT_UNAVAILABLE() {
    return new fault_t(option_t.DOCK_HEIGHT_UNAVAILABLE);
  }
  static get VIO_INSUFFICIENT_STATIC_TIME_BEFORE_TAKEOFF() {
    return new fault_t(option_t.VIO_INSUFFICIENT_STATIC_TIME_BEFORE_TAKEOFF);
  }
  static get NFS_MOUNT_FAILED() {
    return new fault_t(option_t.NFS_MOUNT_FAILED);
  }
  static get RID_OPERATOR_ID_FAULT() {
    return new fault_t(option_t.RID_OPERATOR_ID_FAULT);
  }
  static get BATTERY_NOT_DOCK_COMPATIBLE() {
    return new fault_t(option_t.BATTERY_NOT_DOCK_COMPATIBLE);
  }
  static get VEHICLE_BLOWING_AWAY() {
    return new fault_t(option_t.VEHICLE_BLOWING_AWAY);
  }
  static get EXT4_CORRUPTION() {
    return new fault_t(option_t.EXT4_CORRUPTION);
  }
  static get LOST_CLOUD_CONNECTION() {
    return new fault_t(option_t.LOST_CLOUD_CONNECTION);
  }
  static get CLOUD_UNREACHABLE() {
    return new fault_t(option_t.CLOUD_UNREACHABLE);
  }
  static get INTERNET_CONNECTION_DEGRADED() {
    return new fault_t(option_t.INTERNET_CONNECTION_DEGRADED);
  }
  static get LINKED_DEVICE_CONNECTION_DEGRADED() {
    return new fault_t(option_t.LINKED_DEVICE_CONNECTION_DEGRADED);
  }
  static get SIMULATOR_SET_CLOUD_TAKEOFF_POINT_ALTITUDE_FAILED() {
    return new fault_t(option_t.SIMULATOR_SET_CLOUD_TAKEOFF_POINT_ALTITUDE_FAILED);
  }
  static get MEDIA_SYNC_ENCRYPTED_DATA_BLOCKED_FROM_UPLOAD() {
    return new fault_t(option_t.MEDIA_SYNC_ENCRYPTED_DATA_BLOCKED_FROM_UPLOAD);
  }
  static get PROCEED_WITH_DRONES_NEARBY() {
    return new fault_t(option_t.PROCEED_WITH_DRONES_NEARBY);
  }
  static get PROCEED_WITH_DRONES_NEARBY_NOT_DISMISSED() {
    return new fault_t(option_t.PROCEED_WITH_DRONES_NEARBY_NOT_DISMISSED);
  }
  static get EXCESSIVE_MOTOR_VIBE_IN_FLIGHT() {
    return new fault_t(option_t.EXCESSIVE_MOTOR_VIBE_IN_FLIGHT);
  }
  static get CONFIGURING_MISSION_ENV() {
    return new fault_t(option_t.CONFIGURING_MISSION_ENV);
  }
  static get STUCK_ON_OTHER_DRONES() {
    return new fault_t(option_t.STUCK_ON_OTHER_DRONES);
  }
  static get TURTLE_MODE_ACTIVE() {
    return new fault_t(option_t.TURTLE_MODE_ACTIVE);
  }
  static get BATTERY_POWER_LIMIT_FORCES_LANDING() {
    return new fault_t(option_t.BATTERY_POWER_LIMIT_FORCES_LANDING);
  }
  static get BATTERY_FRETTING_CRITICAL() {
    return new fault_t(option_t.BATTERY_FRETTING_CRITICAL);
  }
  static get WAIT_FOR_PRECISE_PREP() {
    return new fault_t(option_t.WAIT_FOR_PRECISE_PREP);
  }
  static get WAIT_FOR_PRECISE_LAUNCH() {
    return new fault_t(option_t.WAIT_FOR_PRECISE_LAUNCH);
  }
  static get ENCRYPTION_KEY_ALREADY_PROVISIONED() {
    return new fault_t(option_t.ENCRYPTION_KEY_ALREADY_PROVISIONED);
  }
  static get ENCRYPTION_CLOUD_KEY_UNLOCK_TOKEN_EXPIRED() {
    return new fault_t(option_t.ENCRYPTION_CLOUD_KEY_UNLOCK_TOKEN_EXPIRED);
  }
  static get YUBIKEY_COMMUNICATION_ERROR() {
    return new fault_t(option_t.YUBIKEY_COMMUNICATION_ERROR);
  }
  static get ENCRYPTION_UNLOCK_IN_PROGRESS() {
    return new fault_t(option_t.ENCRYPTION_UNLOCK_IN_PROGRESS);
  }
  static get VEHICLE_GROUNDED_BY_CLOUD_CONFIG() {
    return new fault_t(option_t.VEHICLE_GROUNDED_BY_CLOUD_CONFIG);
  }
  static get BATTERY_SUSPENDED_VIA_DOCK() {
    return new fault_t(option_t.BATTERY_SUSPENDED_VIA_DOCK);
  }
  static get DOCK_ROOF_OPEN_TIMEOUT() {
    return new fault_t(option_t.DOCK_ROOF_OPEN_TIMEOUT);
  }
  static get INSUFFICIENT_RETURN_ENERGY_WITH_NIGHTSENSE() {
    return new fault_t(option_t.INSUFFICIENT_RETURN_ENERGY_WITH_NIGHTSENSE);
  }
  static get NIGHTSENSE_TOO_HOT() {
    return new fault_t(option_t.NIGHTSENSE_TOO_HOT);
  }
  static get FLIGHT_ENVELOPE_LIMITING_POWER() {
    return new fault_t(option_t.FLIGHT_ENVELOPE_LIMITING_POWER);
  }
  static get FOLLOWING_WITHOUT_OA() {
    return new fault_t(option_t.FOLLOWING_WITHOUT_OA);
  }
  static get BATTERY_NOT_LATCHED() {
    return new fault_t(option_t.BATTERY_NOT_LATCHED);
  }
  static get IMU_BIAS_TOO_HIGH() {
    return new fault_t(option_t.IMU_BIAS_TOO_HIGH);
  }
  static get IMU_SATURATING() {
    return new fault_t(option_t.IMU_SATURATING);
  }
  static get BLACKOUT_MODE_SWITCH_NOT_POSSIBLE() {
    return new fault_t(option_t.BLACKOUT_MODE_SWITCH_NOT_POSSIBLE);
  }
  static get RAINING_WITH_DROPPER() {
    return new fault_t(option_t.RAINING_WITH_DROPPER);
  }
  static get RAINING_WITH_DROPPER_NOT_DISMISSED() {
    return new fault_t(option_t.RAINING_WITH_DROPPER_NOT_DISMISSED);
  }
  static get SCENARIO_SIM_FAILED_TO_LOAD_SCENARIO() {
    return new fault_t(option_t.SCENARIO_SIM_FAILED_TO_LOAD_SCENARIO);
  }
  static get ADSB_REGULATORY_MANAGER_ACTIVE() {
    return new fault_t(option_t.ADSB_REGULATORY_MANAGER_ACTIVE);
  }
  static get ADSB_REGULATORY_MANAGER_RESPONDING() {
    return new fault_t(option_t.ADSB_REGULATORY_MANAGER_RESPONDING);
  }
  static get MAX_NUM_FAULTS() {
    return new fault_t(option_t.MAX_NUM_FAULTS);
  }

  public override value: option_t;

  constructor(value?: option_t) {
    super();
    this.value = value ?? option_t.INVALID;
  }

  public override get name(): string {
    return option_t[this.value]!;
  }
}